<template>
  <div>
    <v-row no-glutters class="body-rows">
      <v-col cols="12" md="7" class="left-cols1 pr-md-8">
        <p class="subtitle-2 font-weight-bold mb-2 mb-md-5 txt-666">
          <v-btn to="/signature" icon><v-icon>mdi-arrow-left</v-icon></v-btn> Step 5 of 6
        </p>
        <p v-if="nomis == 0" class="headline font-weight-black mb-2">Would you like to add nominee for your investment?</p>
        <p v-if="nomis == 1" class="headline font-weight-black mb-2">Add Nominee Details</p>

        <p class="subtitle-1 font-weight-regular txt-666">Secure your investments for the future by adding up to 3 nominees.<br> Example - You can split percentages like 40%, 25%, and 35% among them.</p>
        <v-alert v-if="rejectdata.app_status == 'rejected' ? rejectdata.stage_wise_approval.nominee == 'no' : ''" border="left" colored-border type="info" style="border: 1px solid #ebeef0 !important" class="mt-4 mx-auto rounded-xl text-left py-2" color="warning" elevation="0">
          <span class="subtitle-2 font-weight-regular"
            >Your Nominee have been rejected due <b>{{ rejectdata.nominee_reject_reason ? rejectdata.nominee_reject_reason : "" }}</b></span
          >
        </v-alert>
        <div v-if="!dataloader || !cardloader">
          <v-chip-group v-if="nomis == 0" class="py-4" column>
            <v-chip :disabled="cardloader" @click="(nom = tag.val), nomineeUpdation()" :color="nom == tag.val ? '#000' : '#666666'" :text-color="nom == tag.val ? '#fff' : '#666666'" v-for="(tag, l) in noms" :outlined="nom != tag.val" :key="l">
              {{ tag.txt }}
            </v-chip>
          </v-chip-group>
          <div v-if="nomis == 1">
            <v-chip-group column class="mb-4">
              <v-chip @click="panel = 0" :color="panel == 0 ? '#000' : '#666666'" :text-color="panel == 0 ? '#fff' : '#666666'" :outlined="panel != 0">
                1st nominee
                <div v-if="!$v.nominee1.$invalid" class="mt-1 ml-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.707 6.707L7.707 10.707C7.512 10.902 7.256 11 7 11C6.744 11 6.488 10.902 6.293 10.707L4.293 8.707C3.902 8.316 3.902 7.684 4.293 7.293C4.684 6.902 5.316 6.902 5.707 7.293L7 8.586L10.293 5.293C10.684 4.902 11.316 4.902 11.707 5.293C12.098 5.684 12.098 6.316 11.707 6.707Z"
                      fill="#34A853"
                    />
                  </svg>
                </div>
                <v-card v-if="activetab == ''" color="transparent" @click="clearTabo()" class="mt-1 ml-2 elevation-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M11.3333 5.99984L7.33333 9.99984M7.33333 5.99984L11.3333 9.99984M1.81333 8.63984L4.69333 12.4798C4.928 12.7927 5.04533 12.9492 5.19403 13.062C5.32574 13.1619 5.47488 13.2365 5.63385 13.2819C5.81334 13.3332 6.00889 13.3332 6.4 13.3332H11.4667C12.5868 13.3332 13.1468 13.3332 13.5746 13.1152C13.951 12.9234 14.2569 12.6175 14.4487 12.2412C14.6667 11.8133 14.6667 11.2533 14.6667 10.1332V5.8665C14.6667 4.7464 14.6667 4.18635 14.4487 3.75852C14.2569 3.3822 13.951 3.07624 13.5746 2.88449C13.1468 2.6665 12.5868 2.6665 11.4667 2.6665H6.4C6.00889 2.6665 5.81334 2.6665 5.63385 2.71776C5.47488 2.76317 5.32574 2.83774 5.19403 2.93767C5.04533 3.05051 4.928 3.20695 4.69333 3.51984L1.81333 7.35984C1.6412 7.58934 1.55514 7.7041 1.52196 7.83013C1.49268 7.94137 1.49268 8.0583 1.52196 8.16955C1.55514 8.29558 1.6412 8.41033 1.81333 8.63984Z"
                      :stroke="panel == 0 ? '#fff' : '#666666'"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </v-card>
              </v-chip>

              <v-chip @click="panel = 1" :color="panel == 1 ? '#000' : '#666666'" :text-color="panel == 1 ? '#fff' : '#666666'" :outlined="panel != 1" v-if="activetab == 'tab2' || activetab == 'tab3'">
                2nd nominee
                <div v-if="!$v.nominee2.$invalid" class="mt-1 ml-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.707 6.707L7.707 10.707C7.512 10.902 7.256 11 7 11C6.744 11 6.488 10.902 6.293 10.707L4.293 8.707C3.902 8.316 3.902 7.684 4.293 7.293C4.684 6.902 5.316 6.902 5.707 7.293L7 8.586L10.293 5.293C10.684 4.902 11.316 4.902 11.707 5.293C12.098 5.684 12.098 6.316 11.707 6.707Z"
                      fill="#34A853"
                    />
                  </svg>
                </div>
                <v-card v-if="activetab == 'tab2'" color="transparent" @click="clearTabt()" class="mt-1 ml-2 elevation-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M11.3333 5.99984L7.33333 9.99984M7.33333 5.99984L11.3333 9.99984M1.81333 8.63984L4.69333 12.4798C4.928 12.7927 5.04533 12.9492 5.19403 13.062C5.32574 13.1619 5.47488 13.2365 5.63385 13.2819C5.81334 13.3332 6.00889 13.3332 6.4 13.3332H11.4667C12.5868 13.3332 13.1468 13.3332 13.5746 13.1152C13.951 12.9234 14.2569 12.6175 14.4487 12.2412C14.6667 11.8133 14.6667 11.2533 14.6667 10.1332V5.8665C14.6667 4.7464 14.6667 4.18635 14.4487 3.75852C14.2569 3.3822 13.951 3.07624 13.5746 2.88449C13.1468 2.6665 12.5868 2.6665 11.4667 2.6665H6.4C6.00889 2.6665 5.81334 2.6665 5.63385 2.71776C5.47488 2.76317 5.32574 2.83774 5.19403 2.93767C5.04533 3.05051 4.928 3.20695 4.69333 3.51984L1.81333 7.35984C1.6412 7.58934 1.55514 7.7041 1.52196 7.83013C1.49268 7.94137 1.49268 8.0583 1.52196 8.16955C1.55514 8.29558 1.6412 8.41033 1.81333 8.63984Z"
                      :stroke="panel == 1 ? '#fff' : '#666666'"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </v-card>
              </v-chip>

              <v-chip @click="panel = 2" :color="panel == 2 ? '#000' : '#666666'" :text-color="panel == 2 ? '#fff' : '#666666'" :outlined="panel != 2" v-if="activetab == 'tab3'">
                3rd nominee
                <div v-if="!$v.nominee3.$invalid" class="mt-1 ml-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.707 6.707L7.707 10.707C7.512 10.902 7.256 11 7 11C6.744 11 6.488 10.902 6.293 10.707L4.293 8.707C3.902 8.316 3.902 7.684 4.293 7.293C4.684 6.902 5.316 6.902 5.707 7.293L7 8.586L10.293 5.293C10.684 4.902 11.316 4.902 11.707 5.293C12.098 5.684 12.098 6.316 11.707 6.707Z"
                      fill="#34A853"
                    />
                  </svg>
                </div>
                <v-card v-if="activetab == 'tab3'" color="transparent" @click="clearTabr()" class="mt-1 ml-2 elevation-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M11.3333 5.99984L7.33333 9.99984M7.33333 5.99984L11.3333 9.99984M1.81333 8.63984L4.69333 12.4798C4.928 12.7927 5.04533 12.9492 5.19403 13.062C5.32574 13.1619 5.47488 13.2365 5.63385 13.2819C5.81334 13.3332 6.00889 13.3332 6.4 13.3332H11.4667C12.5868 13.3332 13.1468 13.3332 13.5746 13.1152C13.951 12.9234 14.2569 12.6175 14.4487 12.2412C14.6667 11.8133 14.6667 11.2533 14.6667 10.1332V5.8665C14.6667 4.7464 14.6667 4.18635 14.4487 3.75852C14.2569 3.3822 13.951 3.07624 13.5746 2.88449C13.1468 2.6665 12.5868 2.6665 11.4667 2.6665H6.4C6.00889 2.6665 5.81334 2.6665 5.63385 2.71776C5.47488 2.76317 5.32574 2.83774 5.19403 2.93767C5.04533 3.05051 4.928 3.20695 4.69333 3.51984L1.81333 7.35984C1.6412 7.58934 1.55514 7.7041 1.52196 7.83013C1.49268 7.94137 1.49268 8.0583 1.52196 8.16955C1.55514 8.29558 1.6412 8.41033 1.81333 8.63984Z"
                      :stroke="panel == 2 ? '#fff' : '#666666'"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </v-card>
              </v-chip>
            </v-chip-group>

            <div v-if="panel == 0" class="pt-2">
              <v-row no-glutters>
                <v-col class="py-0 pr-0" cols="10">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Full Name</p>
                  <v-text-field   v-on:keypress="isLetter($event)"  class="nom mb-3" v-model="nominee1.n1_name" :error-messages="n1_nameErrors" required @blur="$v.nominee1.n1_name.$touch()"  >
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M14.1333 12.6438C14.1335 12.4937 14.0975 12.3457 14.0282 12.2125C13.959 12.0792 13.8587 11.9647 13.7357 11.8785C12.052 10.7881 10.0709 10.248 8.06667 10.3329C6.06245 10.248 4.08138 10.7881 2.3976 11.8785C2.27466 11.9647 2.17432 12.0792 2.1051 12.2125C2.03588 12.3457 1.99983 12.4937 2 12.6438V14.9996H14.1333V12.6438Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.06647 7.53333C9.8706 7.53333 11.3331 6.0708 11.3331 4.26667C11.3331 2.46254 9.8706 1 8.06647 1C6.26234 1 4.7998 2.46254 4.7998 4.26667C4.7998 6.0708 6.26234 7.53333 8.06647 7.53333Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </template>

                    <template #append>
                      <!--  -->
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0 pl-0" style="padding-top: 26px !important" cols="2">
                  <v-text-field
                    :readonly="activetab == ''"
                    type="number"
                    suffix="%"
                    @change="nomPerChgo()"
                    @keyup="nomPerChgo()"
                    :max="n1_permax"
                    :min="n1_permin"
                    hide-spin-buttons
                    class="nom mb-3"
                    v-model="nominee1.n1_percent"
                    :error-messages="n1_percentErrors"
                    required
                    @blur="$v.nominee1.n1_percent.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth</p>

                  <v-menu ref="n1_menu" v-model="n1_menu" :close-on-content-click="false" max-width="280px" min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{on, attrs}">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="n1_dobErrors" required @blur="$v.nominee1.n1_dob.$touch()" class="nom mb-3" v-model="nominee1.n1_dob" single-line>
                        <template #prepend-inner>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M10.5287 0.667969C10.8047 0.667969 11.0287 0.891969 11.0287 1.16797L11.029 1.73318C12.0024 1.79991 12.8108 2.13333 13.383 2.7067C14.0077 3.33404 14.3363 4.23604 14.333 5.31804V11.4C14.333 13.6214 12.9223 15.0014 10.6523 15.0014H5.01367C2.74367 15.0014 1.33301 13.602 1.33301 11.3494V5.3167C1.33301 3.2215 2.59104 1.8766 4.6428 1.7334L4.64321 1.16797C4.64321 0.891969 4.86721 0.667969 5.14321 0.667969C5.41921 0.667969 5.64321 0.891969 5.64321 1.16797L5.64301 1.72064H10.0283L10.0287 1.16797C10.0287 0.891969 10.2527 0.667969 10.5287 0.667969ZM13.333 6.60397H2.33301V11.3494C2.33301 13.06 3.28501 14.0014 5.01367 14.0014H10.6523C12.381 14.0014 13.333 13.0774 13.333 11.4L13.333 6.60397ZM10.8005 10.7988C11.0765 10.7988 11.3005 11.0228 11.3005 11.2988C11.3005 11.5748 11.0765 11.7988 10.8005 11.7988C10.5245 11.7988 10.2978 11.5748 10.2978 11.2988C10.2978 11.0228 10.5185 10.7988 10.7945 10.7988H10.8005ZM7.84214 10.7988C8.11814 10.7988 8.34214 11.0228 8.34214 11.2988C8.34214 11.5748 8.11814 11.7988 7.84214 11.7988C7.56614 11.7988 7.33947 11.5748 7.33947 11.2988C7.33947 11.0228 7.56014 10.7988 7.83614 10.7988H7.84214ZM4.87761 10.7988C5.15361 10.7988 5.37761 11.0228 5.37761 11.2988C5.37761 11.5748 5.15361 11.7988 4.87761 11.7988C4.60161 11.7988 4.37427 11.5748 4.37427 11.2988C4.37427 11.0228 4.59561 10.7988 4.87161 10.7988H4.87761ZM10.8005 8.2077C11.0765 8.2077 11.3005 8.4317 11.3005 8.7077C11.3005 8.9837 11.0765 9.2077 10.8005 9.2077C10.5245 9.2077 10.2978 8.9837 10.2978 8.7077C10.2978 8.4317 10.5185 8.2077 10.7945 8.2077H10.8005ZM7.84214 8.2077C8.11814 8.2077 8.34214 8.4317 8.34214 8.7077C8.34214 8.9837 8.11814 9.2077 7.84214 9.2077C7.56614 9.2077 7.33947 8.9837 7.33947 8.7077C7.33947 8.4317 7.56014 8.2077 7.83614 8.2077H7.84214ZM4.87761 8.2077C5.15361 8.2077 5.37761 8.4317 5.37761 8.7077C5.37761 8.9837 5.15361 9.2077 4.87761 9.2077C4.60161 9.2077 4.37427 8.9837 4.37427 8.7077C4.37427 8.4317 4.59561 8.2077 4.87161 8.2077H4.87761ZM10.0283 2.72064H5.64301L5.64321 3.36197C5.64321 3.63797 5.41921 3.86197 5.14321 3.86197C4.86721 3.86197 4.64321 3.63797 4.64321 3.36197L4.64285 2.73577C3.14937 2.86123 2.33301 3.76654 2.33301 5.3167V5.60397H13.333L13.333 5.3167C13.3357 4.49337 13.1143 3.85337 12.675 3.41337C12.2894 3.02657 11.7256 2.79557 11.0292 2.73609L11.0287 3.36197C11.0287 3.63797 10.8047 3.86197 10.5287 3.86197C10.2527 3.86197 10.0287 3.63797 10.0287 3.36197L10.0283 2.72064Z"
                              fill="#121212"
                            />
                          </svg>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee1.n1_dob" @input="n1save()" :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)" min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" cols="6">
                  <p class="font-weight-medium fs-17 mb-0">Relationship</p>
                  <v-select  item-disabled="disabled"   :items="relationitems1" append-icon="mdi-chevron-down" class="nom mb-3" v-model="nominee1.n1_relation" :error-messages="n1_relationErrors" required @blur="$v.nominee1.n1_relation.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                      </svg>
                    </template>
                     <template v-slot:item="{ item, attrs, on }">
                     <v-list-item v-on="on" v-bind="attrs">
                      <div class="d-flex justify-space-between align-center" style="width: 100%">
                        <span>{{ item.text }}</span>
                        <v-chip
                          x-small
                          color="#FCF3F3"
                          class="pa-1"
                          v-if="item.disabled == true"
                        >
                          <span style="color: #ff1717; font-size: 10px">
                           You have selected 'Single' as your marital status.
                          </span>
                        </v-chip>
                      </div>
                    </v-list-item>
                    </template>
                  </v-select>
                </v-col>

                     <v-col class="py-0" cols="6">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Mobile No</p>
                   <v-text-field
                   
          required
          type="number"
          hide-spin-buttons
          v-model="nominee1.n1_mobile" 
                   :error-messages="n1_mobileerror"
          oninput="this.value = this.value.replace('  ', '')"
         @blur="$v.nominee1.n1_mobile.$touch()"
          counter="10"
        
     
          class="txt-field"
        
        >
          <template #prepend-inner>
            <div class="mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M11.6667 0.333008H4.33333C3.89147 0.333537 3.46785 0.509302 3.15541 0.821748C2.84296 1.13419 2.6672 1.55781 2.66667 1.99967V13.9997C2.6672 14.4415 2.84296 14.8652 3.15541 15.1776C3.46785 15.49 3.89147 15.6658 4.33333 15.6663H11.6667C12.1085 15.6658 12.5321 15.49 12.8446 15.1776C13.157 14.8652 13.3328 14.4415 13.3333 13.9997V1.99967C13.3328 1.55781 13.157 1.13419 12.8446 0.821748C12.5321 0.509302 12.1085 0.333537 11.6667 0.333008ZM12.6667 12.9997C12.6667 13.0881 12.6315 13.1729 12.569 13.2354C12.5065 13.2979 12.4217 13.333 12.3333 13.333H3.66667C3.57826 13.333 3.49348 13.2979 3.43097 13.2354C3.36845 13.1729 3.33333 13.0881 3.33333 12.9997V1.99967C3.33333 1.91127 3.36845 1.82648 3.43097 1.76397C3.49348 1.70146 3.57826 1.66634 3.66667 1.66634H12.3333C12.4217 1.66634 12.5065 1.70146 12.569 1.76397C12.6315 1.82648 12.6667 1.91127 12.6667 1.99967V12.9997Z"
                  fill="#121212"
                />
                <path
                  d="M9.66666 4H6.33333C6.24492 4 6.16014 3.94732 6.09763 3.85355C6.03511 3.75979 6 3.63261 6 3.5C6 3.36739 6.03511 3.24021 6.09763 3.14645C6.16014 3.05268 6.24492 3 6.33333 3H9.66666C9.75507 3 9.83985 3.05268 9.90237 3.14645C9.96488 3.24021 10 3.36739 10 3.5C10 3.63261 9.96488 3.75979 9.90237 3.85355C9.83985 3.94732 9.75507 4 9.66666 4Z"
                  fill="#121212"
                />
              </svg>
            </div>
          </template>
       
        </v-text-field>

                </v-col>
                <v-col class="py-0" cols="6">
                     <p class="font-weight-medium fs-17 mb-0">
            Nominee  email address
          
          </p>

          <v-text-field  v-model="nominee1.n1_email" required   :error-messages="n1_emailerror"
          
         @blur="$v.nominee1.n1_email.$touch()" type="email" placeholder="Enter email address" class="txt-field">
            <template #prepend-inner>
              <div class="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                  <path
                    d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </template>
         
          </v-text-field>
                </v-col>

                  <v-col class="py-0 mt-4" cols="6">
                     <p class="font-weight-medium fs-17 ">
           Nominee's identity proof
          
          </p>

           <v-select
  :items="proffitems"
  item-text="value"
  item-value="type"
  v-model="nominee1.n1_proofType"
  append-icon="mdi-chevron-down"
  class="nom mb-3"
  :error-messages="n1_idproofErrors"
  required
  @blur="$v.nominee1.n1_proofType.$touch()"
>
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                      </svg>
                    </template>
                   
                  </v-select>
                </v-col>

                    <v-col class="py-0 mt-4" cols="6">
                     <p class="font-weight-medium fs-17 mb-0">
           Nominee {{viewnomineeprofftype(nominee1.n1_proofType)}}
          
             <v-text-field  v-model="nominee1.n1_pan" required   :error-messages="n1_proofErrors"
          
         @blur="$v.nominee1.n1_pan.$touch()"  class="txt-field">
            <template #prepend-inner>
              <div class="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                  <path
                    d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </template>
         
          </v-text-field>
          </p>

        
                </v-col>
      

                <v-checkbox color="#000" @change="noAdds()" v-model="nominee1.n1_addrCB" class="ma-0 ml-4">
                  <template #label>
                    <p class="mb-0 subtitle-2 black--text font-weight-medium">Nominee address is same as my address <span :style="`color: ${nominee1.n1_addrCB ? '#0037B7' : '#999'};`">Click to Change it</span></p>
                  </template>
                </v-checkbox>

                <v-col class="py-0" cols="12" v-if="!nominee1.n1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Address</p>
                  <v-text-field @paste="handlePasteadd" class="nom mb-3" v-model="nominee1.n1_addr" oninput="this.value = this.value.replace('  ', '')" :error-messages="n1_addrErrors" required @blur="$v.nominee1.n1_addr.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                        <g clip-path="url(#clip0_1006_4547)">
                          <path d="M5.92754 13.2617H3.33621L1 16.9997H14.0828L11.7466 13.2617H9.15526" stroke="#666666" stroke-width="1.2" stroke-miterlimit="10" />
                          <path
                            d="M12.214 7.45983C12.214 10.2124 7.54157 15.131 7.54157 15.131C7.54157 15.131 2.86914 10.2124 2.86914 7.45983C2.86914 4.63769 5.28385 3 7.54157 3C9.79929 3 12.214 4.63722 12.214 7.45983Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <path
                            d="M7.54138 9.07299C8.31553 9.07299 8.94311 8.44541 8.94311 7.67126C8.94311 6.89711 8.31553 6.26953 7.54138 6.26953C6.76722 6.26953 6.13965 6.89711 6.13965 7.67126C6.13965 8.44541 6.76722 9.07299 7.54138 9.07299Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1006_4547">
                            <rect width="16" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee1.n1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Pincode</p>
                  <v-text-field type="number" hide-spin-buttons class="nom mb-3" @keyup="pincodeValid(nominee1.n1_pincode, $event, 'n1')" v-model="nominee1.n1_pincode" :error-messages="n1_pincodeErrors" required @blur="$v.nominee1.n1_pincode.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee1.n1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">City</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee1.n1_city" :error-messages="n1_cityErrors" required @blur="$v.nominee1.n1_city.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee1.n1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">State</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee1.n1_state" :error-messages="n1_stateErrors" required @blur="$v.nominee1.n1_state.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee1.n1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Country</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee1.n1_country" :error-messages="n1_countryErrors" required @blur="$v.nominee1.n1_country.$touch()"></v-text-field>
                </v-col>

                <p v-if="nominee1.n1_age" class="txt-666 font-weight-medium mx-3 mx-md-0">The nominee is under the age of 18, so guardian details are mandatory.</p>
                <v-col class="py-0" cols="12" v-if="nominee1.n1_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian Full Name</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee1.g1_name" :error-messages="g1_nameErrors" @blur="$v.nominee1.g1_name.$touch()"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="6" v-if="nominee1.n1_age">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth</p>

                  <v-menu ref="g1_menu" v-model="g1_menu" :close-on-content-click="false" max-width="280px" min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{on, attrs}">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="g1_dobErrors" @blur="$v.nominee1.g1_dob.$touch()" class="nom mb-3" v-model="nominee1.g1_dob" single-line hint="Guardian must be over 18 years." persistent-hint> </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee1.g1_dob" @input="g1save()" :max="agevalid" min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="py-0" cols="6" v-if="nominee1.n1_age">
                  <p class="font-weight-medium fs-17 mb-0">Relationship</p>
                  <v-select :items="guardianrelationitems" append-icon="mdi-chevron-down" class="nom mb-3" v-model="nominee1.g1_relation" :error-messages="g1_relationErrors" @blur="$v.nominee1.g1_relation.$touch()"></v-select>
                </v-col>
             

                <v-checkbox color="#000" @change="goAdds()" v-model="nominee1.g1_addrCB" v-if="nominee1.n1_age" class="ma-0 ml-4">
                  <template #label>
                    <p class="mb-0 subtitle-2 black--text font-weight-medium">Nominee address is same as my address <span :style="`color: ${nominee1.g1_addrCB ? '#0037B7' : '#999'};`">Click to Change it</span></p>
                  </template>
                </v-checkbox>

                <v-col class="py-0" cols="12" v-if="nominee1.n1_age && !nominee1.g1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Address</p>
                  <v-text-field class="nom mb-3" v-model="nominee1.g1_addr" oninput="this.value = this.value.replace('  ', '')" :error-messages="g1_addrErrors" required @blur="$v.nominee1.g1_addr.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                        <g clip-path="url(#clip0_1006_4547)">
                          <path d="M5.92754 13.2617H3.33621L1 16.9997H14.0828L11.7466 13.2617H9.15526" stroke="#666666" stroke-width="1.2" stroke-miterlimit="10" />
                          <path
                            d="M12.214 7.45983C12.214 10.2124 7.54157 15.131 7.54157 15.131C7.54157 15.131 2.86914 10.2124 2.86914 7.45983C2.86914 4.63769 5.28385 3 7.54157 3C9.79929 3 12.214 4.63722 12.214 7.45983Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <path
                            d="M7.54138 9.07299C8.31553 9.07299 8.94311 8.44541 8.94311 7.67126C8.94311 6.89711 8.31553 6.26953 7.54138 6.26953C6.76722 6.26953 6.13965 6.89711 6.13965 7.67126C6.13965 8.44541 6.76722 9.07299 7.54138 9.07299Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1006_4547">
                            <rect width="16" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee1.n1_age && !nominee1.g1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Pincode</p>
                  <v-text-field type="number" hide-spin-buttons class="nom mb-3" @keyup="pincodeValid(nominee1.g1_pincode, $event, 'g1')" v-model="nominee1.g1_pincode" :error-messages="g1_pincodeErrors" required @blur="$v.nominee1.g1_pincode.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee1.n1_age && !nominee1.g1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">City</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee1.g1_city" :error-messages="g1_cityErrors" required @blur="$v.nominee1.g1_city.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee1.n1_age && !nominee1.g1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">State</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee1.g1_state" :error-messages="g1_stateErrors" required @blur="$v.nominee1.g1_state.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee1.n1_age && !nominee1.g1_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Country</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee1.g1_country" :error-messages="g1_countryErrors" required @blur="$v.nominee1.g1_country.$touch()"></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div v-if="panel == 1" class="pt-2">
              <v-row no-glutters>
                <v-col class="py-0 pr-0" cols="10">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Full Name</p>
                  <v-text-field  v-on:keypress="isLetter($event)"   class="nom mb-3" v-model="nominee2.n2_name" :error-messages="n2_nameErrors" required @blur="$v.nominee2.n2_name.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M14.1333 12.6438C14.1335 12.4937 14.0975 12.3457 14.0282 12.2125C13.959 12.0792 13.8587 11.9647 13.7357 11.8785C12.052 10.7881 10.0709 10.248 8.06667 10.3329C6.06245 10.248 4.08138 10.7881 2.3976 11.8785C2.27466 11.9647 2.17432 12.0792 2.1051 12.2125C2.03588 12.3457 1.99983 12.4937 2 12.6438V14.9996H14.1333V12.6438Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.06647 7.53333C9.8706 7.53333 11.3331 6.0708 11.3331 4.26667C11.3331 2.46254 9.8706 1 8.06647 1C6.26234 1 4.7998 2.46254 4.7998 4.26667C4.7998 6.0708 6.26234 7.53333 8.06647 7.53333Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </template>

                    <template #append>
                      <!--  -->
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0 pl-0" style="padding-top: 26px !important" cols="2">
                  <v-text-field
                    :readonly="activetab == ''"
                    type="number"
                    suffix="%"
                    @change="nomPerChgt()"
                    @keyup="nomPerChgt()"
                    :max="n2_permax"
                    :min="n2_permin"
                    hide-spin-buttons
                    class="nom mb-3"
                    v-model="nominee2.n2_percent"
                    :error-messages="n2_percentErrors"
                    required
                    @blur="$v.nominee2.n2_percent.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth</p>

                  <v-menu ref="n2_menu" v-model="n2_menu" :close-on-content-click="false" max-width="280px" min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{on, attrs}">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="n2_dobErrors" required @blur="$v.nominee2.n2_dob.$touch()" class="nom mb-3" v-model="nominee2.n2_dob" single-line>
                        <template #prepend-inner>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M10.5287 0.667969C10.8047 0.667969 11.0287 0.891969 11.0287 1.16797L11.029 1.73318C12.0024 1.79991 12.8108 2.13333 13.383 2.7067C14.0077 3.33404 14.3363 4.23604 14.333 5.31804V11.4C14.333 13.6214 12.9223 15.0014 10.6523 15.0014H5.01367C2.74367 15.0014 1.33301 13.602 1.33301 11.3494V5.3167C1.33301 3.2215 2.59104 1.8766 4.6428 1.7334L4.64321 1.16797C4.64321 0.891969 4.86721 0.667969 5.14321 0.667969C5.41921 0.667969 5.64321 0.891969 5.64321 1.16797L5.64301 1.72064H10.0283L10.0287 1.16797C10.0287 0.891969 10.2527 0.667969 10.5287 0.667969ZM13.333 6.60397H2.33301V11.3494C2.33301 13.06 3.28501 14.0014 5.01367 14.0014H10.6523C12.381 14.0014 13.333 13.0774 13.333 11.4L13.333 6.60397ZM10.8005 10.7988C11.0765 10.7988 11.3005 11.0228 11.3005 11.2988C11.3005 11.5748 11.0765 11.7988 10.8005 11.7988C10.5245 11.7988 10.2978 11.5748 10.2978 11.2988C10.2978 11.0228 10.5185 10.7988 10.7945 10.7988H10.8005ZM7.84214 10.7988C8.11814 10.7988 8.34214 11.0228 8.34214 11.2988C8.34214 11.5748 8.11814 11.7988 7.84214 11.7988C7.56614 11.7988 7.33947 11.5748 7.33947 11.2988C7.33947 11.0228 7.56014 10.7988 7.83614 10.7988H7.84214ZM4.87761 10.7988C5.15361 10.7988 5.37761 11.0228 5.37761 11.2988C5.37761 11.5748 5.15361 11.7988 4.87761 11.7988C4.60161 11.7988 4.37427 11.5748 4.37427 11.2988C4.37427 11.0228 4.59561 10.7988 4.87161 10.7988H4.87761ZM10.8005 8.2077C11.0765 8.2077 11.3005 8.4317 11.3005 8.7077C11.3005 8.9837 11.0765 9.2077 10.8005 9.2077C10.5245 9.2077 10.2978 8.9837 10.2978 8.7077C10.2978 8.4317 10.5185 8.2077 10.7945 8.2077H10.8005ZM7.84214 8.2077C8.11814 8.2077 8.34214 8.4317 8.34214 8.7077C8.34214 8.9837 8.11814 9.2077 7.84214 9.2077C7.56614 9.2077 7.33947 8.9837 7.33947 8.7077C7.33947 8.4317 7.56014 8.2077 7.83614 8.2077H7.84214ZM4.87761 8.2077C5.15361 8.2077 5.37761 8.4317 5.37761 8.7077C5.37761 8.9837 5.15361 9.2077 4.87761 9.2077C4.60161 9.2077 4.37427 8.9837 4.37427 8.7077C4.37427 8.4317 4.59561 8.2077 4.87161 8.2077H4.87761ZM10.0283 2.72064H5.64301L5.64321 3.36197C5.64321 3.63797 5.41921 3.86197 5.14321 3.86197C4.86721 3.86197 4.64321 3.63797 4.64321 3.36197L4.64285 2.73577C3.14937 2.86123 2.33301 3.76654 2.33301 5.3167V5.60397H13.333L13.333 5.3167C13.3357 4.49337 13.1143 3.85337 12.675 3.41337C12.2894 3.02657 11.7256 2.79557 11.0292 2.73609L11.0287 3.36197C11.0287 3.63797 10.8047 3.86197 10.5287 3.86197C10.2527 3.86197 10.0287 3.63797 10.0287 3.36197L10.0283 2.72064Z"
                              fill="#121212"
                            />
                          </svg>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee2.n2_dob" @input="n2save()" :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)" min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" cols="6">
                  <p class="font-weight-medium fs-17 mb-0">Relationship</p>
                  <v-select item-disabled="disabled" :items="relationitems1" append-icon="mdi-chevron-down" class="nom mb-3" v-model="nominee2.n2_relation" :error-messages="n2_relationErrors" required @blur="$v.nominee2.n2_relation.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                      </svg>
                    </template>
                          <template v-slot:item="{ item, attrs, on }">
                     <v-list-item v-on="on" v-bind="attrs">
                      <div class="d-flex justify-space-between align-center" style="width: 100%">
                        <span>{{ item.text }}</span>
                        <v-chip
                          x-small
                          color="#FCF3F3"
                          class="pa-1"
                          v-if="item.disabled == true"
                        >
                          <span style="color: #ff1717; font-size: 10px">
                           You have selected 'Single' as your marital status.
                          </span>
                        </v-chip>
                      </div>
                    </v-list-item>
                    </template>
                  </v-select>
                </v-col>
                        <v-col class="py-0" cols="6">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Mobile No</p>
                   <v-text-field
          required
          type="number"
          hide-spin-buttons
          v-model="nominee2.n2_mobile" 
                   :error-messages="n2_mobileerror"
           oninput="this.value = this.value.replace('  ', '')"
         @blur="$v.nominee2.n2_mobile.$touch()"
          counter="10"
        
     
          class="txt-field"
        
        >
          <template #prepend-inner>
            <div class="mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M11.6667 0.333008H4.33333C3.89147 0.333537 3.46785 0.509302 3.15541 0.821748C2.84296 1.13419 2.6672 1.55781 2.66667 1.99967V13.9997C2.6672 14.4415 2.84296 14.8652 3.15541 15.1776C3.46785 15.49 3.89147 15.6658 4.33333 15.6663H11.6667C12.1085 15.6658 12.5321 15.49 12.8446 15.1776C13.157 14.8652 13.3328 14.4415 13.3333 13.9997V1.99967C13.3328 1.55781 13.157 1.13419 12.8446 0.821748C12.5321 0.509302 12.1085 0.333537 11.6667 0.333008ZM12.6667 12.9997C12.6667 13.0881 12.6315 13.1729 12.569 13.2354C12.5065 13.2979 12.4217 13.333 12.3333 13.333H3.66667C3.57826 13.333 3.49348 13.2979 3.43097 13.2354C3.36845 13.1729 3.33333 13.0881 3.33333 12.9997V1.99967C3.33333 1.91127 3.36845 1.82648 3.43097 1.76397C3.49348 1.70146 3.57826 1.66634 3.66667 1.66634H12.3333C12.4217 1.66634 12.5065 1.70146 12.569 1.76397C12.6315 1.82648 12.6667 1.91127 12.6667 1.99967V12.9997Z"
                  fill="#121212"
                />
                <path
                  d="M9.66666 4H6.33333C6.24492 4 6.16014 3.94732 6.09763 3.85355C6.03511 3.75979 6 3.63261 6 3.5C6 3.36739 6.03511 3.24021 6.09763 3.14645C6.16014 3.05268 6.24492 3 6.33333 3H9.66666C9.75507 3 9.83985 3.05268 9.90237 3.14645C9.96488 3.24021 10 3.36739 10 3.5C10 3.63261 9.96488 3.75979 9.90237 3.85355C9.83985 3.94732 9.75507 4 9.66666 4Z"
                  fill="#121212"
                />
              </svg>
            </div>
          </template>
       
        </v-text-field>

                </v-col>
                <v-col class="py-0" cols="6">
                     <p class="font-weight-medium fs-17 mb-0">
            Nominee  email address
          
          </p>

          <v-text-field  v-model="nominee2.n2_email" required   :error-messages="n2_emailerror"
          
         @blur="$v.nominee2.n2_email.$touch()" type="email" placeholder="Enter email address" class="txt-field">
            <template #prepend-inner>
              <div class="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                  <path
                    d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </template>
         
          </v-text-field>
                </v-col>

                 <v-col class="py-0 mt-4" cols="6">
                     <p class="font-weight-medium fs-17 ">
           Nominee's identity proof
          
          </p>

            <v-select
  :items="proffitems"
  item-text="value"
  item-value="type"
  v-model="nominee2.n2_proofType"
  append-icon="mdi-chevron-down"
  class="nom mb-3"
  :error-messages="n2_idproofErrors"
  required
  @blur="$v.nominee2.n2_proofType.$touch()"
>
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                      </svg>
                    </template>
                    
                  </v-select>
                </v-col>

                    <v-col class="py-0 mt-4" cols="6">
                     <p class="font-weight-medium fs-17 mb-0">
           Nominee {{viewnomineeprofftype(nominee2.n2_proofType)}}
          
             <v-text-field  v-model="nominee2.n2_pan" required   :error-messages="n2_proofErrors"
          
         @blur="$v.nominee2.n2_pan.$touch()"  class="txt-field">
            <template #prepend-inner>
              <div class="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                  <path
                    d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </template>
         
          </v-text-field>
          </p>

        
                </v-col>

                <v-checkbox color="#000" @change="ntAdds()" v-model="nominee2.n2_addrCB" class="ma-0 ml-4">
                  <template #label>
                    <p class="mb-0 subtitle-2 black--text font-weight-medium">Nominee address is same as my address <span :style="`color: ${nominee2.n2_addrCB ? '#0037B7' : '#999'};`">Click to Change it</span></p>
                  </template>
                </v-checkbox>

                <v-col class="py-0" cols="12" v-if="!nominee2.n2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Address</p>
                  <v-text-field class="nom mb-3" @paste="handlePasteadd" v-model="nominee2.n2_addr" oninput="this.value = this.value.replace('  ', '')" :error-messages="n2_addrErrors" required @blur="$v.nominee2.n2_addr.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                        <g clip-path="url(#clip0_1006_4547)">
                          <path d="M5.92754 13.2617H3.33621L1 16.9997H14.0828L11.7466 13.2617H9.15526" stroke="#666666" stroke-width="1.2" stroke-miterlimit="10" />
                          <path
                            d="M12.214 7.45983C12.214 10.2124 7.54157 15.131 7.54157 15.131C7.54157 15.131 2.86914 10.2124 2.86914 7.45983C2.86914 4.63769 5.28385 3 7.54157 3C9.79929 3 12.214 4.63722 12.214 7.45983Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <path
                            d="M7.54138 9.07299C8.31553 9.07299 8.94311 8.44541 8.94311 7.67126C8.94311 6.89711 8.31553 6.26953 7.54138 6.26953C6.76722 6.26953 6.13965 6.89711 6.13965 7.67126C6.13965 8.44541 6.76722 9.07299 7.54138 9.07299Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1006_4547">
                            <rect width="16" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee2.n2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Pincode</p>
                  <v-text-field type="number" hide-spin-buttons class="nom mb-3" @keyup="pincodeValid(nominee2.n2_pincode, $event, 'n2')" v-model="nominee2.n2_pincode" :error-messages="n2_pincodeErrors" required @blur="$v.nominee2.n2_pincode.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee2.n2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">City</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee2.n2_city" :error-messages="n2_cityErrors" required @blur="$v.nominee2.n2_city.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee2.n2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">State</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee2.n2_state" :error-messages="n2_stateErrors" required @blur="$v.nominee2.n2_state.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee2.n2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Country</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee2.n2_country" :error-messages="n2_countryErrors" required @blur="$v.nominee2.n2_country.$touch()"></v-text-field>
                </v-col>

                <p v-if="nominee2.n2_age" class="txt-666 font-weight-medium mx-3 mx-md-0">The nominee is under the age of 18, so guardian details are mandatory.</p>
                <v-col class="py-0" cols="12" v-if="nominee2.n2_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian Full Name</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee2.g2_name" :error-messages="g2_nameErrors" @blur="$v.nominee2.g2_name.$touch()"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="6" v-if="nominee2.n2_age">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth</p>

                  <v-menu ref="g2_menu" v-model="g2_menu" :close-on-content-click="false" max-width="280px" min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{on, attrs}">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="g2_dobErrors" @blur="$v.nominee2.g2_dob.$touch()" class="nom mb-3" v-model="nominee2.g2_dob" single-line hint="Guardian must be over 18 years." persistent-hint> </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee2.g2_dob" @input="g2save()" :max="agevalid" min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee2.n2_age">
                  <p class="font-weight-medium fs-17 mb-0">Relationship</p>
                  <v-select :items="guardianrelationitems" append-icon="mdi-chevron-down" class="nom mb-3" v-model="nominee2.g2_relation" :error-messages="g2_relationErrors" @blur="$v.nominee2.g2_relation.$touch()"></v-select>
                </v-col>

                <v-checkbox color="#000" @change="gtAdds()" v-model="nominee2.g2_addrCB" v-if="nominee2.n2_age" class="ma-0 ml-4">
                  <template #label>
                    <p class="mb-0 subtitle-2 black--text font-weight-medium">Nominee address is same as my address <span :style="`color: ${nominee2.g2_addrCB ? '#0037B7' : '#999'};`">Click to Change it</span></p>
                  </template>
                </v-checkbox>

                <v-col class="py-0" cols="12" v-if="nominee2.n2_age && !nominee2.g2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Address</p>
                  <v-text-field class="nom mb-3" v-model="nominee2.g2_addr" oninput="this.value = this.value.replace('  ', '')" :error-messages="g2_addrErrors" required @blur="$v.nominee2.g2_addr.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                        <g clip-path="url(#clip0_1006_4547)">
                          <path d="M5.92754 13.2617H3.33621L1 16.9997H14.0828L11.7466 13.2617H9.15526" stroke="#666666" stroke-width="1.2" stroke-miterlimit="10" />
                          <path
                            d="M12.214 7.45983C12.214 10.2124 7.54157 15.131 7.54157 15.131C7.54157 15.131 2.86914 10.2124 2.86914 7.45983C2.86914 4.63769 5.28385 3 7.54157 3C9.79929 3 12.214 4.63722 12.214 7.45983Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <path
                            d="M7.54138 9.07299C8.31553 9.07299 8.94311 8.44541 8.94311 7.67126C8.94311 6.89711 8.31553 6.26953 7.54138 6.26953C6.76722 6.26953 6.13965 6.89711 6.13965 7.67126C6.13965 8.44541 6.76722 9.07299 7.54138 9.07299Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1006_4547">
                            <rect width="16" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee2.n2_age && !nominee2.g2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Pincode</p>
                  <v-text-field type="number" hide-spin-buttons class="nom mb-3" @keyup="pincodeValid(nominee2.g2_pincode, $event, 'g2')" v-model="nominee2.g2_pincode" :error-messages="g2_pincodeErrors" required @blur="$v.nominee2.g2_pincode.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee2.n2_age && !nominee2.g2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">City</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee2.g2_city" :error-messages="g2_cityErrors" required @blur="$v.nominee2.g2_city.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee2.n2_age && !nominee2.g2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">State</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee2.g2_state" :error-messages="g2_stateErrors" required @blur="$v.nominee2.g2_state.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee2.n2_age && !nominee2.g2_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Country</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee2.g2_country" :error-messages="g2_countryErrors" required @blur="$v.nominee2.g2_country.$touch()"></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div v-if="panel == 2" class="pt-2">
              <v-row no-glutters>
                <v-col class="py-0 pr-0" cols="10">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Full Name</p>
                  <v-text-field   v-on:keypress="isLetter($event)"  class="nom mb-3" v-model="nominee3.n3_name" :error-messages="n3_nameErrors" required @blur="$v.nominee3.n3_name.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M14.1333 12.6438C14.1335 12.4937 14.0975 12.3457 14.0282 12.2125C13.959 12.0792 13.8587 11.9647 13.7357 11.8785C12.052 10.7881 10.0709 10.248 8.06667 10.3329C6.06245 10.248 4.08138 10.7881 2.3976 11.8785C2.27466 11.9647 2.17432 12.0792 2.1051 12.2125C2.03588 12.3457 1.99983 12.4937 2 12.6438V14.9996H14.1333V12.6438Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.06647 7.53333C9.8706 7.53333 11.3331 6.0708 11.3331 4.26667C11.3331 2.46254 9.8706 1 8.06647 1C6.26234 1 4.7998 2.46254 4.7998 4.26667C4.7998 6.0708 6.26234 7.53333 8.06647 7.53333Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </template>

                    <template #append>
                      <!--  -->
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0 pl-0" style="padding-top: 26px !important" cols="2">
                  <v-text-field
                    :readonly="activetab == ''"
                    type="number"
                    suffix="%"
                    @change="nomPerChgr()"
                    @keyup="nomPerChgr()"
                    :max="n3_permax"
                    :min="n3_permin"
                    hide-spin-buttons
                    class="nom mb-3"
                    v-model="nominee3.n3_percent"
                    :error-messages="n3_percentErrors"
                    required
                    @blur="$v.nominee3.n3_percent.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth</p>

                  <v-menu ref="n3_menu" v-model="n3_menu" :close-on-content-click="false" max-width="280px" min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{on, attrs}">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="n3_dobErrors" required @blur="$v.nominee3.n3_dob.$touch()" class="nom mb-3" v-model="nominee3.n3_dob" single-line>
                        <template #prepend-inner>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M10.5287 0.667969C10.8047 0.667969 11.0287 0.891969 11.0287 1.16797L11.029 1.73318C12.0024 1.79991 12.8108 2.13333 13.383 2.7067C14.0077 3.33404 14.3363 4.23604 14.333 5.31804V11.4C14.333 13.6214 12.9223 15.0014 10.6523 15.0014H5.01367C2.74367 15.0014 1.33301 13.602 1.33301 11.3494V5.3167C1.33301 3.2215 2.59104 1.8766 4.6428 1.7334L4.64321 1.16797C4.64321 0.891969 4.86721 0.667969 5.14321 0.667969C5.41921 0.667969 5.64321 0.891969 5.64321 1.16797L5.64301 1.72064H10.0283L10.0287 1.16797C10.0287 0.891969 10.2527 0.667969 10.5287 0.667969ZM13.333 6.60397H2.33301V11.3494C2.33301 13.06 3.28501 14.0014 5.01367 14.0014H10.6523C12.381 14.0014 13.333 13.0774 13.333 11.4L13.333 6.60397ZM10.8005 10.7988C11.0765 10.7988 11.3005 11.0228 11.3005 11.2988C11.3005 11.5748 11.0765 11.7988 10.8005 11.7988C10.5245 11.7988 10.2978 11.5748 10.2978 11.2988C10.2978 11.0228 10.5185 10.7988 10.7945 10.7988H10.8005ZM7.84214 10.7988C8.11814 10.7988 8.34214 11.0228 8.34214 11.2988C8.34214 11.5748 8.11814 11.7988 7.84214 11.7988C7.56614 11.7988 7.33947 11.5748 7.33947 11.2988C7.33947 11.0228 7.56014 10.7988 7.83614 10.7988H7.84214ZM4.87761 10.7988C5.15361 10.7988 5.37761 11.0228 5.37761 11.2988C5.37761 11.5748 5.15361 11.7988 4.87761 11.7988C4.60161 11.7988 4.37427 11.5748 4.37427 11.2988C4.37427 11.0228 4.59561 10.7988 4.87161 10.7988H4.87761ZM10.8005 8.2077C11.0765 8.2077 11.3005 8.4317 11.3005 8.7077C11.3005 8.9837 11.0765 9.2077 10.8005 9.2077C10.5245 9.2077 10.2978 8.9837 10.2978 8.7077C10.2978 8.4317 10.5185 8.2077 10.7945 8.2077H10.8005ZM7.84214 8.2077C8.11814 8.2077 8.34214 8.4317 8.34214 8.7077C8.34214 8.9837 8.11814 9.2077 7.84214 9.2077C7.56614 9.2077 7.33947 8.9837 7.33947 8.7077C7.33947 8.4317 7.56014 8.2077 7.83614 8.2077H7.84214ZM4.87761 8.2077C5.15361 8.2077 5.37761 8.4317 5.37761 8.7077C5.37761 8.9837 5.15361 9.2077 4.87761 9.2077C4.60161 9.2077 4.37427 8.9837 4.37427 8.7077C4.37427 8.4317 4.59561 8.2077 4.87161 8.2077H4.87761ZM10.0283 2.72064H5.64301L5.64321 3.36197C5.64321 3.63797 5.41921 3.86197 5.14321 3.86197C4.86721 3.86197 4.64321 3.63797 4.64321 3.36197L4.64285 2.73577C3.14937 2.86123 2.33301 3.76654 2.33301 5.3167V5.60397H13.333L13.333 5.3167C13.3357 4.49337 13.1143 3.85337 12.675 3.41337C12.2894 3.02657 11.7256 2.79557 11.0292 2.73609L11.0287 3.36197C11.0287 3.63797 10.8047 3.86197 10.5287 3.86197C10.2527 3.86197 10.0287 3.63797 10.0287 3.36197L10.0283 2.72064Z"
                              fill="#121212"
                            />
                          </svg>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee3.n3_dob" @input="n3save()" :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)" min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" cols="6">
                  <p class="font-weight-medium fs-17 mb-0">Relationship</p>
                  <v-select item-disabled="disabled"   :items="relationitems1" append-icon="mdi-chevron-down" class="nom mb-3" v-model="nominee3.n3_relation" :error-messages="n3_relationErrors" required @blur="$v.nominee3.n3_relation.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                      </svg>
                    </template>
                          <template v-slot:item="{ item, attrs, on }">
                     <v-list-item v-on="on" v-bind="attrs">
                      <div class="d-flex justify-space-between align-center" style="width: 100%">
                        <span>{{ item.text }}</span>
                        <v-chip
                          x-small
                          color="#FCF3F3"
                          class="pa-1"
                          v-if="item.disabled == true"
                        >
                          <span style="color: #ff1717; font-size: 10px">
                          You have selected 'Single' as your marital status.
                          </span>
                        </v-chip>
                      </div>
                    </v-list-item>
                    </template>
                  </v-select>
                </v-col>

                <v-col class="py-0" cols="6">
                  <p class="font-weight-medium fs-17 mb-0">Nominee Mobile No</p>
                   <v-text-field
          required
          type="number"
          hide-spin-buttons
          v-model="nominee3.n3_mobile" 
                   :error-messages="n3_mobileerror"
           oninput="this.value = this.value.replace('  ', '')"
         @blur="$v.nominee3.n3_mobile.$touch()"
          counter="10"
        
     
          class="txt-field"
        
        >
          <template #prepend-inner>
            <div class="mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M11.6667 0.333008H4.33333C3.89147 0.333537 3.46785 0.509302 3.15541 0.821748C2.84296 1.13419 2.6672 1.55781 2.66667 1.99967V13.9997C2.6672 14.4415 2.84296 14.8652 3.15541 15.1776C3.46785 15.49 3.89147 15.6658 4.33333 15.6663H11.6667C12.1085 15.6658 12.5321 15.49 12.8446 15.1776C13.157 14.8652 13.3328 14.4415 13.3333 13.9997V1.99967C13.3328 1.55781 13.157 1.13419 12.8446 0.821748C12.5321 0.509302 12.1085 0.333537 11.6667 0.333008ZM12.6667 12.9997C12.6667 13.0881 12.6315 13.1729 12.569 13.2354C12.5065 13.2979 12.4217 13.333 12.3333 13.333H3.66667C3.57826 13.333 3.49348 13.2979 3.43097 13.2354C3.36845 13.1729 3.33333 13.0881 3.33333 12.9997V1.99967C3.33333 1.91127 3.36845 1.82648 3.43097 1.76397C3.49348 1.70146 3.57826 1.66634 3.66667 1.66634H12.3333C12.4217 1.66634 12.5065 1.70146 12.569 1.76397C12.6315 1.82648 12.6667 1.91127 12.6667 1.99967V12.9997Z"
                  fill="#121212"
                />
                <path
                  d="M9.66666 4H6.33333C6.24492 4 6.16014 3.94732 6.09763 3.85355C6.03511 3.75979 6 3.63261 6 3.5C6 3.36739 6.03511 3.24021 6.09763 3.14645C6.16014 3.05268 6.24492 3 6.33333 3H9.66666C9.75507 3 9.83985 3.05268 9.90237 3.14645C9.96488 3.24021 10 3.36739 10 3.5C10 3.63261 9.96488 3.75979 9.90237 3.85355C9.83985 3.94732 9.75507 4 9.66666 4Z"
                  fill="#121212"
                />
              </svg>
            </div>
          </template>
       
        </v-text-field>

                </v-col>
                <v-col class="py-0" cols="6">
                     <p class="font-weight-medium fs-17 mb-0">
            Nominee  email address
          
          </p>

          <v-text-field  v-model="nominee3.n3_email" required   :error-messages="n3_emailerror"
          
         @blur="$v.nominee3.n3_email.$touch()" type="email" placeholder="Enter email address" class="txt-field">
            <template #prepend-inner>
              <div class="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                  <path
                    d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </template>
         
          </v-text-field>
                </v-col>

                     <v-col class="py-0 mt-4" cols="6">
                     <p class="font-weight-medium fs-17 ">
           Nominee's identity proof
          
          </p>

               <v-select
  :items="proffitems"
  item-text="value"
  item-value="type"
  v-model="nominee3.n3_proofType"
  append-icon="mdi-chevron-down"
  class="nom mb-3"
  :error-messages="n3_idproofErrors"
  required
  @blur="$v.nominee3.n3_proofType.$touch()"
>
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10.75 3.39286C10.75 2.62354 11.3735 2 12.1429 2C12.9122 2 13.5357 2.62354 13.5357 3.39286C13.5357 4.16218 13.0522 5.25 12.1429 5.25C11.2143 5.25 10.75 4.16218 10.75 3.39286Z" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square" />
                        <path
                          d="M14.9289 9.42829V8.04356C14.9289 7.71392 14.7559 7.41074 14.4722 7.2429C14.0207 6.9757 13.2379 6.64258 12.1431 6.64258C11.0342 6.64258 10.2565 6.97361 9.80964 7.24035C9.52828 7.40842 9.35742 7.71067 9.35742 8.03845V9.42829H14.9289Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M9.35714 15.0008H1V13.0316C1 12.2075 1.54043 11.4834 2.33088 11.2494C3.07071 11.0303 4.06614 10.8223 5.17857 10.8223C6.27266 10.8223 7.27413 11.0337 8.02232 11.255C8.81416 11.489 9.35714 12.2126 9.35714 13.0383V15.0008Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M2.85742 6.17885C2.85742 4.89673 3.89673 3.85742 5.17885 3.85742C6.46098 3.85742 7.50028 4.89673 7.50028 6.17885C7.50028 7.46098 6.46098 8.96456 5.17885 8.96456C3.89673 8.96456 2.85742 7.46098 2.85742 6.17885Z"
                          stroke="#212121"
                          stroke-width="1.2"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                      </svg>
                    </template>
                   
                  </v-select>
                </v-col>

                    <v-col class="py-0 mt-4" cols="6">
                     <p class="font-weight-medium fs-17 mb-0">
           Nominee {{viewnomineeprofftype(nominee3.n3_proofType)}}
          
             <v-text-field  v-model="nominee3.n3_pan" required   :error-messages="n3_proofErrors"
          
         @blur="$v.nominee3.n3_pan.$touch()"  class="txt-field">
            <template #prepend-inner>
              <div class="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M1 8.04199V12.6253C1 12.99 1.14487 13.3397 1.40273 13.5976C1.66059 13.8555 2.01033 14.0003 2.375 14.0003H13.375C13.7397 14.0003 14.0894 13.8555 14.3473 13.5976C14.6051 13.3397 14.75 12.99 14.75 12.6253V8.04199"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                  <path
                    d="M14.75 5.75V4.375C14.75 4.01033 14.6051 3.66059 14.3473 3.40273C14.0894 3.14487 13.7397 3 13.375 3H2.375C2.01033 3 1.66059 3.14487 1.40273 3.40273C1.14487 3.66059 1 4.01033 1 4.375V5.75L7.875 9.41667L14.75 5.75Z"
                    stroke="#666666"
                    stroke-width="1.6"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </template>
         
          </v-text-field>
          </p>

        
                </v-col>

                <v-checkbox color="#000" @change="nrAdds()" v-model="nominee3.n3_addrCB" class="ma-0 ml-4">
                  <template #label>
                    <p class="mb-0 subtitle-2 black--text font-weight-medium">Nominee address is same as my address <span :style="`color: ${nominee3.n3_addrCB ? '#0037B7' : '#999'};`">Click to Change it</span></p>
                  </template>
                </v-checkbox>

                <v-col class="py-0" cols="12" v-if="!nominee3.n3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Address</p>
                  <v-text-field class="nom mb-3" @paste="handlePasteadd" v-model="nominee3.n3_addr" oninput="this.value = this.value.replace('  ', '')" :error-messages="n3_addrErrors" required @blur="$v.nominee3.n3_addr.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                        <g clip-path="url(#clip0_1006_4547)">
                          <path d="M5.92754 13.2617H3.33621L1 16.9997H14.0828L11.7466 13.2617H9.15526" stroke="#666666" stroke-width="1.2" stroke-miterlimit="10" />
                          <path
                            d="M12.214 7.45983C12.214 10.2124 7.54157 15.131 7.54157 15.131C7.54157 15.131 2.86914 10.2124 2.86914 7.45983C2.86914 4.63769 5.28385 3 7.54157 3C9.79929 3 12.214 4.63722 12.214 7.45983Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <path
                            d="M7.54138 9.07299C8.31553 9.07299 8.94311 8.44541 8.94311 7.67126C8.94311 6.89711 8.31553 6.26953 7.54138 6.26953C6.76722 6.26953 6.13965 6.89711 6.13965 7.67126C6.13965 8.44541 6.76722 9.07299 7.54138 9.07299Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1006_4547">
                            <rect width="16" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee3.n3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Pincode</p>
                  <v-text-field type="number" hide-spin-buttons class="nom mb-3" @keyup="pincodeValid(nominee3.n3_pincode, $event, 'n3')" v-model="nominee3.n3_pincode" :error-messages="n3_pincodeErrors" required @blur="$v.nominee3.n3_pincode.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee3.n3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">City</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee3.n3_city" :error-messages="n3_cityErrors" required @blur="$v.nominee3.n3_city.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee3.n3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">State</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee3.n3_state" :error-messages="n3_stateErrors" required @blur="$v.nominee3.n3_state.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="!nominee3.n3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Country</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee3.n3_country" :error-messages="n3_countryErrors" required @blur="$v.nominee3.n3_country.$touch()"></v-text-field>
                </v-col>

                <p v-if="nominee3.n3_age" class="txt-666 font-weight-medium mx-3 mx-md-0">The nominee is under the age of 18, so guardian details are mandatory.</p>
                <v-col class="py-0" cols="12" v-if="nominee3.n3_age">
                  <p class="font-weight-medium fs-17 mb-0">Guardian Full Name</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee3.g3_name" :error-messages="g3_nameErrors" @blur="$v.nominee3.g3_name.$touch()"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="6" v-if="nominee3.n3_age">
                  <p class="font-weight-medium fs-17 mb-0">Date of birth</p>
                  <v-menu ref="g3_menu" v-model="g3_menu" :close-on-content-click="false" max-width="280px" min-width="auto" transition="scale-transition" offset-y>
                    <template v-slot:activator="{on, attrs}">
                      <v-text-field v-bind="attrs" v-on="on" readonly :error-messages="g3_dobErrors" @blur="$v.nominee3.g3_dob.$touch()" class="nom mb-3" v-model="nominee3.g3_dob" single-line hint="Guardian must be over 18 years." persistent-hint> </v-text-field>
                    </template>
                    <v-date-picker no-title class="nom" v-model="nominee3.g3_dob" @input="g3save()" :max="agevalid" min="1940-01-01"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="py-0" cols="6" v-if="nominee3.n3_age">
                  <p class="font-weight-medium fs-17 mb-0">Relationship</p>
                  <v-select :items="guardianrelationitems" append-icon="mdi-chevron-down" class="nom mb-3" v-model="nominee3.g3_relation" :error-messages="g3_relationErrors" @blur="$v.nominee3.g3_relation.$touch()"></v-select>
                </v-col>

                <v-checkbox color="#000" @change="grAdds()" v-model="nominee3.g3_addrCB" v-if="nominee3.n3_age" class="ma-0 ml-4">
                  <template #label>
                    <p class="mb-0 subtitle-2 black--text font-weight-medium">Nominee address is same as my address <span :style="`color: ${nominee3.g3_addrCB ? '#0037B7' : '#999'};`">Click to Change it</span></p>
                  </template>
                </v-checkbox>

                <v-col class="py-0" cols="12" v-if="nominee3.n3_age && !nominee3.g3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Address</p>
                  <v-text-field class="nom mb-3" v-model="nominee3.g3_addr" oninput="this.value = this.value.replace('  ', '')" :error-messages="g3_addrErrors" required @blur="$v.nominee3.g3_addr.$touch()">
                    <template #prepend-inner>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                        <g clip-path="url(#clip0_1006_4547)">
                          <path d="M5.92754 13.2617H3.33621L1 16.9997H14.0828L11.7466 13.2617H9.15526" stroke="#666666" stroke-width="1.2" stroke-miterlimit="10" />
                          <path
                            d="M12.214 7.45983C12.214 10.2124 7.54157 15.131 7.54157 15.131C7.54157 15.131 2.86914 10.2124 2.86914 7.45983C2.86914 4.63769 5.28385 3 7.54157 3C9.79929 3 12.214 4.63722 12.214 7.45983Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <path
                            d="M7.54138 9.07299C8.31553 9.07299 8.94311 8.44541 8.94311 7.67126C8.94311 6.89711 8.31553 6.26953 7.54138 6.26953C6.76722 6.26953 6.13965 6.89711 6.13965 7.67126C6.13965 8.44541 6.76722 9.07299 7.54138 9.07299Z"
                            stroke="#666666"
                            stroke-width="1.1"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1006_4547">
                            <rect width="16" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee3.n3_age && !nominee3.g3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Pincode</p>
                  <v-text-field type="number" hide-spin-buttons class="nom mb-3" @keyup="pincodeValid(nominee3.g3_pincode, $event, 'g3')" v-model="nominee3.g3_pincode" :error-messages="g3_pincodeErrors" required @blur="$v.nominee3.g3_pincode.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee3.n3_age && !nominee3.g3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">City</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee3.g3_city" :error-messages="g3_cityErrors" required @blur="$v.nominee3.g3_city.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee3.n3_age && !nominee3.g3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">State</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee3.g3_state" :error-messages="g3_stateErrors" required @blur="$v.nominee3.g3_state.$touch()"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="nominee3.n3_age && !nominee3.g3_addrCB">
                  <p class="font-weight-medium fs-17 mb-0">Country</p>
                  <v-text-field v-on:keypress="isLetter($event)" oninput="this.value = this.value.replace('  ', '')" class="nom mb-3" v-model="nominee3.g3_country" :error-messages="g3_countryErrors" required @blur="$v.nominee3.g3_country.$touch()"></v-text-field>
                </v-col>
              </v-row>
            </div>

            <div class="d-md-inline-flex">
              <v-btn
                v-if="activetab != 'tab2' && activetab != 'tab3'"
                :style="`border: 2px solid ${$v.nominee1.$invalid || cardloader ? '#F2F3F2' : '#444'} !important;`"
                outlined
                height="48px"
                color="#000"
                :disabled="$v.nominee1.$invalid || cardloader"
                @click="(activetab = 'tab2'), (nominee1.n1_percent = 50), (nominee2.n2_percent = 50), (panel = 1), (n1_permax = 99), (n2_permax = 99), (nominee2.n2_addrCB = true), (nominee2.g2_addrCB = true), ntAdds(), gtAdds()"
                class="text-none rounded-pill elevation-0 mt-6 mr-4"
                ><span class="subtitle-1 font-weight-medium px-6">+ Add 2nd Nominee</span></v-btn
              >

              <v-btn
                v-if="activetab == 'tab2'"
                :style="`border: 2px solid ${$v.nominee1.$invalid || $v.nominee2.$invalid || cardloader ? '#F2F3F2' : '#444'} !important;`"
                outlined
                height="48px"
                color="#000"
                :disabled="$v.nominee1.$invalid || $v.nominee2.$invalid || cardloader"
                @click="(activetab = 'tab3'), (nominee1.n1_percent = 40), (nominee2.n2_percent = 30), (nominee3.n3_percent = 30), (panel = 2), (n1_permax = 98), (n2_permax = 98), (n2_permax = 98), (nominee3.n3_addrCB = true), (nominee3.g3_addrCB = true), nrAdds(), grAdds()"
                class="text-none rounded-pill elevation-0 mt-6 mr-4"
                ><span class="subtitle-1 font-weight-medium px-6">+ Add 3rd Nominee</span></v-btn
              >

              <v-btn
                height="48px"
                :loading="cardloader"
                @click="setNominee()"
                :disabled="$v.nominee1.$invalid || ($v.nominee2.$invalid && activetab == 'tab2') || ($v.nominee3.$invalid && activetab == 'tab3') || cardloader"
                color="#000"
                class="d-none d-md-flex white--text text-none rounded-pill elevation-0 mt-6"
                ><span class="white--text subtitle-1 font-weight-medium px-6">Continue</span></v-btn
              >
            </div>

            <v-footer padless color="#fff" class="btn-footer btn-footer px-3 pt-3 pb-1 d-md-none d-flex">
              <v-row no-glutters>
                <v-col cols="6" class="pr-2">
                  <v-btn
                    v-if="activetab != 'tab2' && activetab != 'tab3'"
                    block
                    :style="`border: 2px solid ${$v.nominee1.$invalid || cardloader ? '#F2F3F2' : '#444'} !important;`"
                    outlined
                    height="48px"
                    color="#000"
                    :disabled="$v.nominee1.$invalid || cardloader"
                    @click="(activetab = 'tab2'), (nominee1.n1_percent = 50), (nominee2.n2_percent = 50), (panel = 1), (n1_permax = 99), (n2_permax = 99), (nominee2.n2_addrCB = true), (nominee2.g2_addrCB = true), ntAdds(), gtAdds()"
                    class="text-none rounded-pill elevation-0"
                    ><span class="subtitle-1 font-weight-medium">+ Add 2nd Nominee</span></v-btn
                  >
                  <v-btn
                    v-if="activetab == 'tab2'"
                    block
                    :style="`border: 2px solid ${$v.nominee1.$invalid || $v.nominee2.$invalid || cardloader ? '#F2F3F2' : '#444'} !important;`"
                    outlined
                    height="48px"
                    color="#000"
                    :disabled="$v.nominee1.$invalid || $v.nominee2.$invalid || cardloader"
                    @click="(activetab = 'tab3'), (nominee1.n1_percent = 40), (nominee2.n2_percent = 30), (nominee3.n3_percent = 30), (panel = 2), (n1_permax = 98), (n2_permax = 98), (n2_permax = 98), (nominee3.n3_addrCB = true), (nominee3.g3_addrCB = true), nrAdds(), grAdds()"
                    class="text-none rounded-pill elevation-0"
                    ><span class="subtitle-1 font-weight-medium">+ Add 3rd Nominee</span></v-btn
                  >
                </v-col>
                <v-col cols="6" class="pl-2">
                  <v-btn
                    height="48px"
                    :loading="cardloader"
                    @click="setNominee()"
                    block
                    :disabled="$v.nominee1.$invalid || ($v.nominee2.$invalid && activetab == 'tab2') || ($v.nominee3.$invalid && activetab == 'tab3') || cardloader"
                    color="#000"
                    class="white--text text-none rounded-pill elevation-0"
                    ><span class="white--text subtitle-1 font-weight-medium">Continue</span></v-btn
                  >
                </v-col>
              </v-row>
            </v-footer>
          </div>
        </div>
        <div v-else>
          <v-card width="100%" class="text-center py-16 elevation-0 mt-10">
            <v-progress-circular class="mx-auto" :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
          </v-card>
        </div>
      </v-col>
      <v-col cols="5" class="rgt-cols d-none d-md-block pt-0">
        <v-container fill-height class="d-block text-center">
          <img src="@/assets/nom.svg" class="rgt-img" alt="rgt-img" />
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/api";
import {validationMixin} from "vuelidate";
import {required, minLength, maxLength, between} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  validations() {
    var returnData = {nominee1: {}, nominee2: {}, nominee3: {}};
    const startsWithValidDigit = value => {
  return /^\d{10}$/.test(value) && /^[6-9]/.test(value);
};
const strictEmail = value => {
  if (!value) return true; 
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(value);
};
const isPan = (value) => {
  if (!value) return false;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return panRegex.test(value);
};

const isAadhaarLast4 = (value) => {
  if (!value) return false;
  const aadhaarRegex = /^[0-9]{4}$/;
  return aadhaarRegex.test(value);
};

const isDrivingLicence = (value) => {
  if (!value) return false;
  const dlRegex = /^[A-Z]{2}[0-9]{2}[0-9]{11}$/; // example pattern, adjust as needed
  return dlRegex.test(value);
};



    if (this.nominee1.n1_age == false) {
      returnData.nominee1 = {};
      returnData.nominee1["n1_name"] = {required, minLength: minLength(4)};
      returnData.nominee1["n1_dob"] = {required};
      returnData.nominee1["n1_relation"] = {required};
      returnData.nominee1["n1_proofType"] = {required};
    returnData.nominee1["n1_pan"] = { required,
    conditionalFormat: (value) => {
      if (!value) return false;
      switch (this.nominee1.n1_proofType) {
        case "PAN":
          return isPan(value);
        case "AADHAR":
          return isAadhaarLast4(value);
        case "PROFF OF IDENTITY":
          return isDrivingLicence(value);
        default:
          return false;
      }
    },};
      returnData.nominee1["n1_mobile"] = {required, minLength: minLength(10),maxLength: maxLength(10),startsWithValidDigit};
      returnData.nominee1["n1_email"] = {required,strictEmail};
      returnData.nominee1["n1_percent"] = {required, between: between(1, 100)};
      returnData.nominee1["n1_addr"] = {required, maxLength: maxLength(150)};
      returnData.nominee1["n1_city"] = {required};
      returnData.nominee1["n1_state"] = {required};
      returnData.nominee1["n1_country"] = {required};
      returnData.nominee1["n1_pincode"] = {required, between: between(110000, 999999)};
    } else {
      returnData.nominee1 = {};
      returnData.nominee1["n1_name"] = {required, minLength: minLength(4)};
      returnData.nominee1["n1_dob"] = {required};
      returnData.nominee1["n1_relation"] = {required};
       returnData.nominee1["n1_proofType"] = {required};
    returnData.nominee1["n1_pan"] = { required,
    conditionalFormat: (value) => {
      if (!value) return false;
      switch (this.nominee1.n1_proofType) {
        case "PAN":
          return isPan(value);
        case "AADHAR":
          return isAadhaarLast4(value);
        case "PROFF OF IDENTITY":
          return isDrivingLicence(value);
        default:
          return false;
      }
    },};
      returnData.nominee1["n1_mobile"] = {required, minLength: minLength(10),maxLength: maxLength(10),startsWithValidDigit};
      returnData.nominee1["n1_email"] = {required,strictEmail};
      returnData.nominee1["n1_percent"] = {required, between: between(1, 100)};
      returnData.nominee1["n1_addr"] = {required, maxLength: maxLength(150)};
      returnData.nominee1["n1_city"] = {required};
      returnData.nominee1["n1_state"] = {required};
      returnData.nominee1["n1_country"] = {required};
      returnData.nominee1["n1_pincode"] = {required, between: between(110000, 999999)};
      returnData.nominee1["g1_name"] = {required, minLength: minLength(4)};
      returnData.nominee1["g1_dob"] = {required};
      returnData.nominee1["g1_relation"] = {required};
      returnData.nominee1["g1_addr"] = {required, maxLength: maxLength(150)};
      returnData.nominee1["g1_city"] = {required};
      returnData.nominee1["g1_state"] = {required};
      returnData.nominee1["g1_country"] = {required};
      returnData.nominee1["g1_pincode"] = {required, between: between(110000, 999999)};
    }
    if (this.nominee2.n2_age == false) {
      returnData.nominee2 = {};
      returnData.nominee2["n2_name"] = {required, minLength: minLength(4)};
      returnData.nominee2["n2_dob"] = {required};
      returnData.nominee2["n2_relation"] = {required};
      returnData.nominee2["n2_proofType"] = {required};
    returnData.nominee2["n2_pan"] = { required,
    conditionalFormat: (value) => {
      if (!value) return false;
      switch (this.nominee2.n2_proofType) {
       case "PAN":
          return isPan(value);
        case "AADHAR":
          return isAadhaarLast4(value);
        case "PROFF OF IDENTITY":
          return isDrivingLicence(value);
        default:
          return false;
      }
    },};
       returnData.nominee2["n2_mobile"] = {required, minLength: minLength(10),maxLength: maxLength(10),startsWithValidDigit};
      returnData.nominee2["n2_email"] = {required,strictEmail};
      returnData.nominee2["n2_percent"] = {required, between: between(1, 100)};
      returnData.nominee2["n2_addr"] = {required, maxLength: maxLength(150)};
      returnData.nominee2["n2_city"] = {required};
      returnData.nominee2["n2_state"] = {required};
      returnData.nominee2["n2_country"] = {required};
      returnData.nominee2["n2_pincode"] = {required, between: between(110000, 999999)};
    } else {
      returnData.nominee2 = {};
      returnData.nominee2["n2_name"] = {required, minLength: minLength(4)};
      returnData.nominee2["n2_dob"] = {required};
      returnData.nominee2["n2_relation"] = {required};
        returnData.nominee2["n2_proofType"] = {required};
    returnData.nominee2["n2_pan"] = { required,
    conditionalFormat: (value) => {
      if (!value) return false;
      switch (this.nominee2.n2_proofType) {
       case "PAN":
          return isPan(value);
        case "AADHAR":
          return isAadhaarLast4(value);
        case "PROFF OF IDENTITY":
          return isDrivingLicence(value);
        default:
          return false;
      }
    },};
       returnData.nominee2["n2_mobile"] = {required, minLength: minLength(10),maxLength: maxLength(10),startsWithValidDigit};
      returnData.nominee2["n2_email"] = {required,strictEmail};
      returnData.nominee2["n2_percent"] = {required, between: between(1, 100)};
      returnData.nominee2["n2_addr"] = {required, maxLength: maxLength(150)};
      returnData.nominee2["n2_city"] = {required};
      returnData.nominee2["n2_state"] = {required};
      returnData.nominee2["n2_country"] = {required};
      returnData.nominee2["n2_pincode"] = {required, between: between(110000, 999999)};
      returnData.nominee2["g2_name"] = {required, minLength: minLength(4)};
      returnData.nominee2["g2_dob"] = {required};
      returnData.nominee2["g2_relation"] = {required};
      returnData.nominee2["g2_addr"] = {required, maxLength: maxLength(150)};
      returnData.nominee2["g2_city"] = {required};
      returnData.nominee2["g2_state"] = {required};
      returnData.nominee2["g2_country"] = {required};
      returnData.nominee2["g2_pincode"] = {required, between: between(110000, 999999)};
    }

    if (this.nominee3.n3_age == false) {
      returnData.nominee3 = {};
      returnData.nominee3["n3_name"] = {required, minLength: minLength(4)};
      returnData.nominee3["n3_dob"] = {required};
      returnData.nominee3["n3_relation"] = {required};
        returnData.nominee3["n3_proofType"] = {required};
    returnData.nominee3["n3_pan"] = { required,
    conditionalFormat: (value) => {
      if (!value) return false;
      switch (this.nominee3.n3_proofType) {
      case "PAN":
          return isPan(value);
        case "AADHAR":
          return isAadhaarLast4(value);
        case "PROFF OF IDENTITY":
          return isDrivingLicence(value);
        default:
          return false;
      }
    },};
      returnData.nominee3["n3_mobile"] = {required, minLength: minLength(10),maxLength: maxLength(10),startsWithValidDigit};
      returnData.nominee3["n3_email"] = {required,strictEmail};
      returnData.nominee3["n3_percent"] = {required, between: between(1, 100)};
      returnData.nominee3["n3_addr"] = {required, maxLength: maxLength(150)};
      returnData.nominee3["n3_city"] = {required};
      returnData.nominee3["n3_state"] = {required};
      returnData.nominee3["n3_country"] = {required};
      returnData.nominee3["n3_pincode"] = {required, between: between(110000, 999999)};
    } else {
      returnData.nominee3 = {};
      returnData.nominee3["n3_name"] = {required, minLength: minLength(4)};
      returnData.nominee3["n3_dob"] = {required};
      returnData.nominee3["n3_relation"] = {required};
         returnData.nominee3["n3_proofType"] = {required};
    returnData.nominee3["n3_pan"] = { required,
    conditionalFormat: (value) => {
      if (!value) return false;
      switch (this.nominee3.n3_proofType) {
      case "PAN":
          return isPan(value);
        case "AADHAR":
          return isAadhaarLast4(value);
        case "PROFF OF IDENTITY":
          return isDrivingLicence(value);
        default:
          return false;
      }
    },};
      returnData.nominee3["n3_mobile"] = {required, minLength: minLength(10),maxLength: maxLength(10),startsWithValidDigit};
      returnData.nominee3["n3_email"] = {required,strictEmail};
      returnData.nominee3["n3_percent"] = {required, between: between(1, 100)};
      returnData.nominee3["n3_addr"] = {required, maxLength: maxLength(150)};
      returnData.nominee3["n3_city"] = {required};
      returnData.nominee3["n3_state"] = {required};
      returnData.nominee3["n3_country"] = {required};
      returnData.nominee3["n3_pincode"] = {required, between: between(110000, 999999)};
      returnData.nominee3["g3_name"] = {required, minLength: minLength(4)};
      returnData.nominee3["g3_dob"] = {required};
      returnData.nominee3["g3_relation"] = {required};
      returnData.nominee3["g3_addr"] = {required, maxLength: maxLength(150)};
      returnData.nominee3["g3_city"] = {required};
      returnData.nominee3["g3_state"] = {required};
      returnData.nominee3["g3_country"] = {required};
      returnData.nominee3["g3_pincode"] = {required, between: between(110000, 999999)};
    }
    return returnData;
  },

  data: () => ({
    name: "",
    noms: [
      {txt: "Yes, Add a Nomine", val: "Yes"},
      {txt: "No, I’ll Add Later", val: "No"},
    ],
    nom: "",
    nomis: 0,
    /////////////////
    panel: 0,
    tab: null,
    activePicker: null,
    // menu: false,
    cardloader: false,
    n1_menu: false,
    n2_menu: false,
    n3_menu: false,
    g1_menu: false,
    g2_menu: false,
    g3_menu: false,
    activetab: "",
    relationitems: ["Father", "Mother", "Brother", "Sister", "Son", "Daughter", "Husband", "Wife", "Grand-Father", "Grand-Mother", "Grand-Son", "Grand-Daughter"],
    guardianrelationitems: ["Father", "Mother", "Son", "Daughter", "Brother", "Sister", "Grand-Son", "Grand-Daughter"],
    proffitems:[{"type":"PAN","value":"PAN Number"},{"type":"AADHAR","value":"Aadhaar number(last 4 digits)"},{"type":"PROFF OF IDENTITY","value":"Driving Licence Number"}],
    nominee1: {
      n1_name: "",
      n1_email: "",
      n1_mobile: "",
      n1_pan: "",
      n1_dob: "",
      n1_age: "",
      n1_relation: "",
      n1_percent: 100,
      n1_addrCB: true,
      n1_addr: "",
      n1_addr2: "",
      n1_city: "",
      n1_state: "",
      n1_country: "",
      n1_pincode: "",
      n1_proofType: "AADHAR",
      n1_proof: "",
      g1_name: "",
      g1_email: "",
      g1_mobile: "",
      g1_dob: "",
      g1_relation: "",
      g1_addrCB: true,
      g1_addr: "",
      g1_city: "",
      g1_state: "",
      g1_country: "",
      g1_pincode: "",
    },
    nominee2: {
      n2_name: "",
      n2_email: "",
      n2_mobile: "",
      n2_pan: "",
      n2_dob: "",
      n2_age: "",
      n2_relation: "",
      n2_percent: "",
      n2_addrCB: true,
      n2_addr: "",
      n2_addr2: "",
      n2_city: "",
      n2_state: "",
      n2_country: "",
      n2_pincode: "",
      n2_proofType: "AADHAR",
      n2_proof: "",
      g2_name: "",
      g2_email: "",
      g2_mobile: "",
      g2_dob: "",
      g2_relation: "",
      g2_addrCB: true,
      g2_addr: "",
      g2_city: "",
      g2_state: "",
      g2_country: "",
      g2_pincode: "",
    },
    nominee3: {
      n3_name: "",
      n3_email: "",
      n3_mobile: "",
      n3_pan: "",
      n3_dob: "",
      n3_age: "",
      n3_relation: "",
      n3_percent: "",
      n3_addrCB: true,
      n3_addr: "",
      n3_addr2: "",
      n3_city: "",
      n3_state: "",
      n3_country: "",
      n3_pincode: "",
      n3_proofType: "AADHAR",
      n3_proof: "",
      g3_name: "",
      g3_email: "",
      g3_mobile: "",
      g3_dob: "",
      g3_relation: "",
      g3_addrCB: true,
      g3_addr: "",
      g3_city: "",
      g3_state: "",
      g3_country: "",
      g3_pincode: "",
    },
    nomi1: {
      n1_name: "",
      n1_email: "",
      n1_mobile: "",
      n1_pan: "",
      n1_dob: "",
      n1_age: "",
      n1_relation: "",
      n1_percent: "",
      n1_addrCB: "",
      n1_addr: "",
      n1_addr2: "",
      n1_city: "",
      n1_state: "",
      n1_country: "",
      n1_pincode: "",
      n1_proofType: "",
      n1_proof: "",
      g1_name: "",
      g1_email: "",
      g1_mobile: "",
      g1_dob: "",
      g1_relation: "",
      g1_addrCB: "",
      g1_addr: "",
      g1_city: "",
      g1_state: "",
      g1_country: "",
      g1_pincode: "",
    },
    nomi2: {
      n2_name: "",
      n2_email: "",
      n2_mobile: "",
      n2_pan: "",
      n2_dob: "",
      n2_age: "",
      n2_relation: "",
      n2_percent: "",
      n2_addrCB: "",
      n2_addr: "",
      n2_addr2: "",
      n2_city: "",
      n2_state: "",
      n2_country: "",
      n2_pincode: "",
      n2_proofType: "",
      n2_proof: "",
      g2_name: "",
      g2_email: "",
      g2_mobile: "",
      g2_dob: "",
      g2_relation: "",
      g2_addrCB: "",
      g2_addr: "",
      g2_city: "",
      g2_state: "",
      g2_country: "",
      g2_pincode: "",
    },
    nomi3: {
      n3_name: "",
      n3_email: "",
      n3_mobile: "",
      n3_pan: "",
      n3_dob: "",
      n3_age: "",
      n3_relation: "",
      n3_percent: "",
      n3_addrCB: "",
      n3_addr: "",
      n3_addr2: "",
      n3_city: "",
      n3_state: "",
      n3_country: "",
      n3_pincode: "",
      n3_proofType: "",
      n3_proof: "",
      g3_name: "",
      g3_email: "",
      g3_mobile: "",
      g3_dob: "",
      g3_relation: "",
      g3_addrCB: "",
      g3_addr: "",
      g3_city: "",
      g3_state: "",
      g3_country: "",
      g3_pincode: "",
    },

    gud: {
      g1: {
        g1_name: "",
        g1_email: "",
        g1_mobile: "",
        g1_dob: "",
        g1_relation: "",
        g1_addrCB: "",
        g1_addr: "",
        g1_city: "",
        g1_state: "",
        g1_country: "",
        g1_pincode: "",
      },
      g2: {
        g2_name: "",
        g2_email: "",
        g2_mobile: "",
        g2_dob: "",
        g2_relation: "",
        g2_addrCB: "",
        g2_addr: "",
        g2_city: "",
        g2_state: "",
        g2_country: "",
        g2_pincode: "",
      },
      g3: {
        g3_name: "",
        g3_email: "",
        g3_mobile: "",
        g3_dob: "",
        g3_relation: "",
        g3_addrCB: "",
        g3_addr: "",
        g3_city: "",
        g3_state: "",
        g3_country: "",
        g3_pincode: "",
      },
    },

    n1_permin: 1,
    n2_permin: 1,
    n3_permin: 1,
    n1_permax: 100,
    n2_permax: 50,
    n3_permax: 30,
    sameaddress: {},
    agevalid: `${new Date().getFullYear() - 18}`,
    changenominee: false,

    dataloader: null,
    rejectdata: [],
    getstatresponce:[]
  }),

  created() {
    this.getstatresponce = []
    let config = {
      method: "post",
      url: api.api_url + "/getstart?mob=" + atob(localStorage.getItem("hash")),
      headers: {
        "Content-Type": "application/json",
      },
    };

    let axiosThis = this;
    axios
      .request(config)
      .then((response) => {
        axiosThis.getstatresponce = response.data
        let p = response.data.data_type;
        if (response.data.data_type && response.data.stage_wise_approval.nominee != "yes" && response.data.kra_esigned != 'Yes' && (p.stage == "nominee" || p.stage == "selfie" || p.stage == "submit")) {
          axiosThis.$emit("clicked", 5, response.data);
          response.data.app_status == "rejected" && response.data.stage_wise_approval.nominee == "no" ? (axiosThis.rejectdata = response.data) : (axiosThis.rejectdata = []);
        } else {
          axiosThis.$router.push(p ? {name: p.stage} : "/");
        }
      })
      .catch((error) => {
        console.log(error);
        axiosThis.$emit("snack", 0, error);
      });
  },
  methods: {
  handleInputN1() {
    const regex = /^[a-zA-Z]. *$/;

    if (!regex.test(this.nominee1.n1_name)) {
      this.$nextTick(() => {
        this.nominee1.n1_name = '';
      });
    } 
    if (!regex.test(this.nominee2.n2_name)) {
      this.$nextTick(() => {
        this.nominee2.n2_name = '';
      });
    } 
    if (!regex.test(this.nominee3.n3_name)) {
      this.$nextTick(() => {
        this.nominee3.n3_name = '';
      });
    } 
  },

    handlePaste(event) {
      const pastedText = event.clipboardData.getData('text');
      const regex = /[^a-zA-Z]/g;
      if (regex.test(pastedText)) {
        if(this.nomis == 0){
        this.nominee1.n1_name = ''; 
        }  if(this.nomis == 1){
          this.nominee2.n2_name = ''; 
        }  if(this.nomis == 2){
          this.nominee3.n3_name = ''; 
        }
        event.preventDefault(); 
      }
    },
    handlePasteadd(event) {
      const pastedText = event.clipboardData.getData('text');
      const regex = /[^a-zA-Z]/g;
      if (regex.test(pastedText)) {
        if(this.nomis == 0){
        this.nominee1.n1_addr = ''; 
        }  if(this.nomis == 1){
          this.nominee2.n2_addr = ''; 
        }  if(this.nomis == 2){
          this.nominee3.n3_addr = ''; 
        }
        event.preventDefault(); 
      }
    },
    pincodeValid(pc, e, type) {
      let poc = type == "n1" || type == "g1" ? this.nominee1[`${type}_pincode`] : type == "n2" || type == "g2" ? this.nominee2[`${type}_pincode`] : type == "n3" || type == "g3" ? this.nominee3[`${type}_pincode`] : null;
      if (poc.length <= 6) {
        if (poc.length == 6) {
          let config = {
            method: "get",
            url: `https://api.postalpincode.in/pincode/${poc}`,
          };

          let axiosThis = this;
          axios
            .request(config)
            .then((response) => {
              if (response.data && response.data[0].Status == "Success" && response.data[0].PostOffice[0].Block) {
                if (type == "n1" || type == "g1") {
                  axiosThis.nominee1[`${type}_city`] = response.data[0].PostOffice[0].Block != "NA" ? response.data[0].PostOffice[0].Block : "";
                  axiosThis.nominee1[`${type}_state`] = response.data[0].PostOffice[0].State != "NA" ? response.data[0].PostOffice[0].State : "";
                  axiosThis.nominee1[`${type}_country`] = response.data[0].PostOffice[0].Country != "NA" ? response.data[0].PostOffice[0].Country : "";
                  axiosThis.nominee1[`${type}_pincode`] = response.data[0].PostOffice[0].Pincode != "NA" ? response.data[0].PostOffice[0].Pincode : "";
                }
                if (type == "n2" || type == "g2") {
                  axiosThis.nominee2[`${type}_city`] = response.data[0].PostOffice[0].Block != "NA" ? response.data[0].PostOffice[0].Block : "";
                  axiosThis.nominee2[`${type}_state`] = response.data[0].PostOffice[0].State != "NA" ? response.data[0].PostOffice[0].State : "";
                  axiosThis.nominee2[`${type}_country`] = response.data[0].PostOffice[0].Country != "NA" ? response.data[0].PostOffice[0].Country : "";
                  axiosThis.nominee2[`${type}_pincode`] = response.data[0].PostOffice[0].Pincode != "NA" ? response.data[0].PostOffice[0].Pincode : "";
                }
                if (type == "n3" || type == "g3") {
                  axiosThis.nominee3[`${type}_city`] = response.data[0].PostOffice[0].Block != "NA" ? response.data[0].PostOffice[0].Block : "";
                  axiosThis.nominee3[`${type}_state`] = response.data[0].PostOffice[0].State != "NA" ? response.data[0].PostOffice[0].State : "";
                  axiosThis.nominee3[`${type}_country`] = response.data[0].PostOffice[0].Country != "NA" ? response.data[0].PostOffice[0].Country : "";
                  axiosThis.nominee3[`${type}_pincode`] = response.data[0].PostOffice[0].Pincode != "NA" ? response.data[0].PostOffice[0].Pincode : "";
                }
              }
            })
            .catch((error) => {
              console.log(error, e, pc);
            });
        }
      } else {
        e.preventDefault();
      }
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z.\s]$/.test(char) || char == " ") return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },

    toNext() {
      if (this.rejectdata.app_status == "rejected" && this.rejectdata.stage_wise_approval.nominee == "no") {
        this.$emit("steged", "nominee");
      } else {
        this.$emit("clicked", "selfie");
      }
    },
    nomineeUpdation() {
      if (atob(localStorage.getItem("hash")) && this.nom) {
        this.cardloader = true;
        var axiosThis = this;
        var json_data = {
          mobile: atob(localStorage.getItem("hash")),
          nominee_check: axiosThis.nom,
        };
        var config = {
          method: "post",
          url: api.api_url + "/signupGetUserPersonalDetails",
          headers: {"Content-Type": "application/json"},
          data: JSON.stringify(json_data),
        };
        axios(config)
          .then(function (response) {
            if (response.data && response.data.data == "User data has been inserted sucessfully") {
              if (axiosThis.nom == "No") {
                axiosThis.toNext();
              } else if (axiosThis.nom == "Yes") {
                axiosThis.nomis = 1;
                axiosThis.nominee1.n1_percent = 100;
                axiosThis.getSameaddress();
              }
            } else {
              axiosThis.$emit("snack", 2, response.data);
            }
            axiosThis.cardloader = false;
          })
          .catch(function (error) {
            console.log(error);
            axiosThis.cardloader = false;
            axiosThis.$emit("snack", 0, error);
          });
      }
    },
    clearTabo() {
      this.activetab = "";
      this.nominee1 = this.nomi1;
      this.nomis = "";
      this.nom = "";
      this.$v.$reset();
    },
    clearTabt() {
      this.activetab = "";
      this.nominee2 = this.nomi2;
      this.nominee1.n1_percent = 100;
      this.nominee2.n2_percent = "";
      this.nominee3.n3_percent = "";
      this.panel = 0;
    },
    clearTabr() {
      this.activetab = "tab2";
      this.nominee3 = this.nomi3;
      this.nominee1.n1_percent = 50;
      this.nominee2.n2_percent = 50;
      this.nominee3.n3_percent = "";
      this.panel = 1;
    },

    nomPerChgo() {
      let valo = 100 - this.nominee1.n1_percent;
      if (this.activetab == "tab3") {
        this.n1_permax = 98;
        this.n2_permax = 98;
        this.n3_permax = 98;
        this.nominee3.n3_percent = 100 - (Number(this.nominee1.n1_percent) + Number(this.nominee2.n2_percent));
        this.nominee2.n2_percent = valo / 2;
        this.nominee3.n3_percent = valo / 2;
      } else if (this.activetab == "tab2") {
        this.n1_permax = 99;
        this.n2_permax = 99;
        this.nominee2.n2_percent = valo;
      }
    },
    nomPerChgt() {
      let valo = 100 - this.nominee2.n2_percent;
      if (this.activetab == "tab3") {
        this.n1_permax = 98;
        this.n2_permax = 98;
        this.n3_permax = 98;
        this.nominee3.n3_percent = 100 - (Number(this.nominee1.n1_percent) + Number(this.nominee2.n2_percent));
      } else if (this.activetab == "tab2") {
        this.n1_permax = 99;
        this.n2_permax = 99;
        this.nominee1.n1_percent = valo;
      }
    },
    nomPerChgr() {
      this.n1_permax = 98;
      this.n2_permax = 98;
      this.n3_permax = 98;
      let valo = 100 - this.nominee3.n3_percent;
      this.nominee1.n1_percent = valo / 2;
      this.nominee2.n2_percent = valo / 2;
    },
    noAdds() {
      if (this.nominee1.n1_percent > 0 && this.nominee1.n1_addrCB == true) {
        this.nominee1.n1_addr = this.sameaddress.address;
        this.nominee1.n1_city = this.sameaddress.city;
        this.nominee1.n1_state = this.sameaddress.state;
        this.nominee1.n1_country = this.sameaddress.country;
        this.nominee1.n1_pincode = this.sameaddress.pincode;
      } else {
        this.nominee1.n1_addr = "";
        this.nominee1.n1_city = "";
        this.nominee1.n1_state = "";
        this.nominee1.n1_country = "";
        this.nominee1.n1_pincode = "";
      }
    },
    goAdds() {
      if (this.nominee1.n1_age == true && this.nominee1.g1_addrCB == true) {
        this.nominee1.g1_addr = this.sameaddress.address;
        this.nominee1.g1_city = this.sameaddress.city;
        this.nominee1.g1_state = this.sameaddress.state;
        this.nominee1.g1_country = this.sameaddress.country;
        this.nominee1.g1_pincode = this.sameaddress.pincode;
      } else {
        this.nominee1.g1_addr = "";
        this.nominee1.g1_city = "";
        this.nominee1.g1_state = "";
        this.nominee1.g1_country = "";
        this.nominee1.g1_pincode = "";
      }
    },
    ntAdds() {
      if (this.nominee2.n2_percent > 0 && this.nominee2.n2_addrCB == true) {
        this.nominee2.n2_addr = this.sameaddress.address;
        this.nominee2.n2_city = this.sameaddress.city;
        this.nominee2.n2_state = this.sameaddress.state;
        this.nominee2.n2_country = this.sameaddress.country;
        this.nominee2.n2_pincode = this.sameaddress.pincode;
      } else {
        this.nominee2.n2_addr = "";
        this.nominee2.n2_city = "";
        this.nominee2.n2_state = "";
        this.nominee2.n2_country = "";
        this.nominee2.n2_pincode = "";
      }
    },
    gtAdds() {
      if (this.nominee2.n2_age == true && this.nominee2.g2_addrCB == true) {
        this.nominee2.g2_addr = this.sameaddress.address;
        this.nominee2.g2_city = this.sameaddress.city;
        this.nominee2.g2_state = this.sameaddress.state;
        this.nominee2.g2_country = this.sameaddress.country;
        this.nominee2.g2_pincode = this.sameaddress.pincode;
      } else {
        this.nominee2.g2_addr = "";
        this.nominee2.g2_city = "";
        this.nominee2.g2_state = "";
        this.nominee2.g2_country = "";
        this.nominee2.g2_pincode = "";
      }
    },
    nrAdds() {
      if (this.nominee3.n3_percent > 0 && this.nominee3.n3_addrCB == true) {
        this.nominee3.n3_addr = this.sameaddress.address;
        this.nominee3.n3_city = this.sameaddress.city;
        this.nominee3.n3_state = this.sameaddress.state;
        this.nominee3.n3_country = this.sameaddress.country;
        this.nominee3.n3_pincode = this.sameaddress.pincode;
      } else {
        this.nominee3.n3_addr = "";
        this.nominee3.n3_city = "";
        this.nominee3.n3_state = "";
        this.nominee3.n3_country = "";
        this.nominee3.n3_pincode = "";
      }
    },
    grAdds() {
      if (this.nominee3.n3_age == true && this.nominee3.g3_addrCB == true) {
        this.nominee3.g3_addr = this.sameaddress.address;
        this.nominee3.g3_city = this.sameaddress.city;
        this.nominee3.g3_state = this.sameaddress.state;
        this.nominee3.g3_country = this.sameaddress.country;
        this.nominee3.g3_pincode = this.sameaddress.pincode;
      } else {
        this.nominee3.g3_addr = "";
        this.nominee3.g3_city = "";
        this.nominee3.g3_state = "";
        this.nominee3.g3_country = "";
        this.nominee3.g3_pincode = "";
      }
    },
    getSameaddress() {
      let config = {
        method: "post",
        url: api.api_url + "/sameAsAddress",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          mob: atob(localStorage.getItem("hash")),
        }),
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data.address) {
            axiosThis.sameaddress = response.data;
            axiosThis.goAdds();
            axiosThis.noAdds();
            axiosThis.gtAdds();
            axiosThis.ntAdds();
            axiosThis.grAdds();
            axiosThis.nrAdds();
          }
          axiosThis.cardloader = false;
          axiosThis.dataloader = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.$emit("snack", 0, error);
        });
    },
    differentDate(date) {
      var date1 = new Date(date);
      var date2 = new Date();
      var yy = (Math.abs(date1 - date2) / (1000 * 60 * 60 * 24) - 5) / 365;
      return yy != 0 ? yy : 0;
    },

    n1save(n1_dob) {
      this.n1_menu = false;
      this.$refs.n1_menu.save(n1_dob);
      this.nominee1.n1_age = this.differentDate(this.nominee1.n1_dob) >= 18 ? false : true;
      this.goAdds();
    },
    n2save(n2_dob) {
      this.n2_menu = false;
      this.$refs.n2_menu.save(n2_dob);
      this.nominee2.n2_age = this.differentDate(this.nominee2.n2_dob) >= 18 ? false : true;
      this.gtAdds();
    },
    n3save(n3_dob) {
      this.n3_menu = false;
      this.$refs.n3_menu.save(n3_dob);
      this.nominee3.n3_age = this.differentDate(this.nominee3.n3_dob) >= 18 ? false : true;
      this.grAdds();
    },
    g1save(g1_dob) {
      this.g1_menu = false;
      this.$refs.g1_menu.save(g1_dob);
    },
    g2save(g2_dob) {
      this.g2_menu = false;
      this.$refs.g2_menu.save(g2_dob);
    },
    g3save(g3_dob) {
      this.g3_menu = false;
      this.$refs.g3_menu.save(g3_dob);
    },
    setNominee() {
      if (atob(localStorage.getItem("hash")) && !this.$v.nominee1.$invalid) {
        this.cardloader = true;
        this.$v.$reset();
        var axiosThis = this;
        let one = axiosThis.activetab == "tab3" || axiosThis.activetab == "tab2" || axiosThis.activetab == "" ? axiosThis.nominee1 : axiosThis.nomi1;
        let two = axiosThis.activetab == "tab3" || axiosThis.activetab == "tab2" ? axiosThis.nominee2 : axiosThis.nomi2;
        let tre = axiosThis.activetab == "tab3" ? axiosThis.nominee3 : axiosThis.nomi3;
        if (Number(one.n1_percent) + Number(two.n2_percent) + Number(tre.n3_percent) == 100) {
          one.n1_percent = `${one.n1_percent}`;
          two.n2_percent = `${two.n2_percent > 0 ? two.n2_percent : 0}`;
          tre.n3_percent = `${tre.n3_percent > 0 ? tre.n3_percent : 0}`;
          if (one.n1_age == false) {
            one = {...one, ...axiosThis.gud.g1};
          }
          if (two.n2_age == false) {
            two = {...two, ...axiosThis.gud.g2};
          }
          if (tre.n3_age == false) {
            tre = {...tre, ...axiosThis.gud.g3};
          }
          const nomineedata = {objects: [one, two, tre], mobile: atob(localStorage.getItem("hash"))};
          var config = {
            method: "post",
            url: api.api_url + "/signupGetNomineeDetails",
            headers: {"Content-Type": "application/json"},
            data: JSON.stringify(nomineedata),
          };
          axios(config)
            .then(function (response) {
              if (response.data.data == "All Nominee details updated.") {
                axiosThis.$v.$reset();
                axiosThis.toNext();
              } else {
                axiosThis.$emit("snack", 2, response.data);
              }
              axiosThis.cardloader = false;
            })
            .catch(function (error) {
              console.log(error);
              axiosThis.$emit("snack", 0, error);
            });
        } else {
          this.cardloader = false;
          axiosThis.$emit("snack", 2, "The sum of the nominee percentages is equal to 100.");
        }
      }
    },
    viewnomineeprofftype(prooftype){
if(prooftype == 'PAN'){
  return "PAN Number"
}else if(prooftype == 'AADHAR'){
  return "Aadhaar number(last 4 digits)"
}else if(prooftype == 'PROFF OF IDENTITY'){
  return "Driving Licence Number"

}
    },

    getNomineedata() {
      this.dataloader = true;

      var axiosThis = this;
      var json_data = {
        mobile: atob(localStorage.getItem("hash")),
      };
      var config = {
        method: "post",
        url: api.api_url + "/signupGetNomineeDetails",
        headers: {"Content-Type": "application/json"},
        data: JSON.stringify(json_data),
      };
      axios(config)
        .then(function (response) {
          var data = response.data;
          if (data["nominee1"]) {
            axiosThis.nominee1.n1_name = data["nominee1"]["Nom1_name"];
            axiosThis.nominee1.n1_dob = data["nominee1"]["Nom1_DOB"];
            axiosThis.nominee1.n1_relation = data["nominee1"]["Nom1_relation"];
            axiosThis.nominee1.n1_percent = data["nominee1"]["Nom1_percent_feild1"];
            axiosThis.nominee1.n1_email = data["nominee1"]["Nom1_email"];
            axiosThis.nominee1.n1_mobile = data["nominee1"]["Nom1_mobile"];
            axiosThis.nominee1.n1_addr = data["nominee1"]["Nom1_address1"];
            axiosThis.nominee1.n1_city = data["nominee1"]["Nom1_city"];
            axiosThis.nominee1.n1_state = data["nominee1"]["Nom1_state"];
            axiosThis.nominee1.n1_country = data["nominee1"]["Nom1_country"];
            axiosThis.nominee1.n1_pincode = data["nominee1"]["Nom1_pincode"];
            axiosThis.nominee1.n1_proofType =  data["nominee1"]["nom1_doc_type"];
            axiosThis.nominee1.n1_pan = data["nominee1"]["Nom1_PAN"];
            axiosThis.nominee1.n1_addrCB = data["nominee1"]["Nom1_addrCB"] == "True" ? true : false;
            axiosThis.nominee1.n1_age = data["nominee1"]["Nom1_age"] == "True" ? true : false;
            axiosThis.activetab = Number(data["nominee1"]["Nom1_percent_feild1"]) > 0 ? "" : "";
            axiosThis.changenominee = Number(data["nominee1"]["Nom1_percent_feild1"]) > 0 ? true : false;

            if (data["guardian1"]) {
              axiosThis.nominee1.g1_name = data["guardian1"]["Guardian_name"] ? data["guardian1"]["Guardian_name"] : "";
              axiosThis.nominee1.g1_dob = data["guardian1"]["Guardian_dob"] ? data["guardian1"]["Guardian_dob"] : "";
              axiosThis.nominee1.g1_relation = data["guardian1"]["Guardian_relation"] ? data["guardian1"]["Guardian_relation"] : "";
              axiosThis.nominee1.g1_addrCB = data["guardian1"]["Guardian_addrCB"] == "True" ? true : false;
              axiosThis.nominee1.g1_addr = data["guardian1"]["Guardian_addr"] ? data["guardian1"]["Guardian_addr"] : "";
              axiosThis.nominee1.g1_city = data["guardian1"]["Guardian_city"] ? data["guardian1"]["Guardian_city"] : "";
              axiosThis.nominee1.g1_state = data["guardian1"]["Guardian_state"] ? data["guardian1"]["Guardian_state"] : "";
              axiosThis.nominee1.g1_country = data["guardian1"]["Guardian_country"] ? data["guardian1"]["Guardian_country"] : "";
              axiosThis.nominee1.g1_pincode = data["guardian1"]["Guardian_pincode"] ? data["guardian1"]["Guardian_pincode"] : "";
            }
          }

          if (data["nominee2"]) {
            axiosThis.nominee2.n2_name = data["nominee2"]["Nom2_name"];
            axiosThis.nominee2.n2_dob = data["nominee2"]["Nom2_DOB"];
            axiosThis.nominee2.n2_relation = data["nominee2"]["Nom2_relation"];
            axiosThis.nominee2.n2_percent = data["nominee2"]["Nom2_percent_feild1"];
              axiosThis.nominee2.n2_email = data["nominee2"]["Nom2_email"];
            axiosThis.nominee2.n2_mobile = data["nominee2"]["Nom2_mobile"];
            axiosThis.nominee2.n2_addr = data["nominee2"]["Nom2_address1"];
            axiosThis.nominee2.n2_city = data["nominee2"]["Nom2_city"];
            axiosThis.nominee2.n2_state = data["nominee2"]["Nom2_state"];
            axiosThis.nominee2.n2_country = data["nominee2"]["Nom2_country"];
            axiosThis.nominee2.n2_pincode = data["nominee2"]["Nom2_pincode"];
            axiosThis.nominee2.n2_proofType = data["nominee2"]["nom2_doc_type"];
            axiosThis.nominee2.n2_pan = data["nominee2"]["Nom2_PAN"];
            axiosThis.nominee2.n2_addrCB = data["nominee2"]["Nom2_addrCB"] == "True" ? true : false;
            axiosThis.nominee2.n2_age = data["nominee2"]["Nom2_age"] == "True" ? true : false;
            axiosThis.activetab = Number(data["nominee2"]["Nom2_percent_feild1"]) > 0 ? "tab2" : "";

            if (data["guardian2"]) {
              axiosThis.nominee2.g2_name = data["guardian2"]["Guardian_name2"] ? data["guardian2"]["Guardian_name2"] : "";
              axiosThis.nominee2.g2_dob = data["guardian2"]["Guardian_dob2"] ? data["guardian2"]["Guardian_dob2"] : "";
              axiosThis.nominee2.g2_relation = data["guardian2"]["Guardian_relation2"] ? data["guardian2"]["Guardian_relation2"] : "";
              axiosThis.nominee2.g2_addrCB = data["guardian2"]["Guardian_addrCB2"] == "True" ? true : false;
              axiosThis.nominee2.g2_addr = data["guardian2"]["Guardian_addr2"] ? data["guardian2"]["Guardian_addr2"] : "";
              axiosThis.nominee2.g2_city = data["guardian2"]["Guardian_city2"] ? data["guardian2"]["Guardian_city2"] : "";
              axiosThis.nominee2.g2_state = data["guardian2"]["Guardian_state2"] ? data["guardian2"]["Guardian_state2"] : "";
              axiosThis.nominee2.g2_country = data["guardian2"]["Guardian_country2"] ? data["guardian2"]["Guardian_country2"] : "";
              axiosThis.nominee2.g2_pincode = data["guardian2"]["Guardian_pincode2"] ? data["guardian2"]["Guardian_pincode2"] : "";
            }
          }

          if (data["nominee3"]) {
            axiosThis.nominee3.n3_name = data["nominee3"]["Nom3_name"];
            axiosThis.nominee3.n3_dob = data["nominee3"]["Nom3_DOB"];
            axiosThis.nominee3.n3_relation = data["nominee3"]["Nom3_relation"];
            axiosThis.nominee3.n3_percent = data["nominee3"]["Nom3_percent_feild1"];
            axiosThis.nominee3.n3_email = data["nominee3"]["Nom3_email"];
            axiosThis.nominee3.n3_mobile = data["nominee3"]["Nom3_mobile"];
            axiosThis.nominee3.n3_addr = data["nominee3"]["Nom3_address1"];
            axiosThis.nominee3.n3_city = data["nominee3"]["Nom3_city"];
            axiosThis.nominee3.n3_state = data["nominee3"]["Nom3_state"];
            axiosThis.nominee3.n3_country = data["nominee3"]["Nom3_country"];
            axiosThis.nominee3.n3_pincode = data["nominee3"]["Nom3_pincode"];
            axiosThis.nominee3.n3_proofType = data["nominee3"]["nom3_doc_type"];
            axiosThis.nominee3.n3_pan = data["nominee3"]["Nom3_PAN"];
            axiosThis.nominee3.n3_addrCB = data["nominee3"]["Nom3_addrCB"] == "True" ? true : false;
            axiosThis.nominee3.n3_age = data["nominee3"]["Nom3_age"] == "True" ? true : false;
            axiosThis.activetab = Number(data["nominee3"]["Nom3_percent_feild1"]) > 0 ? "tab3" : "";

            if (data["guardian3"]) {
              axiosThis.nominee3.g3_name = data["guardian3"]["Guardian_name3"] ? data["guardian3"]["Guardian_name3"] : "";
              axiosThis.nominee3.g3_dob = data["guardian3"]["Guardian_dob3"] ? data["guardian3"]["Guardian_dob3"] : "";
              axiosThis.nominee3.g3_relation = data["guardian3"]["Guardian_relation3"] ? data["guardian3"]["Guardian_relation3"] : "";
              axiosThis.nominee3.g3_addrCB = data["guardian3"]["Guardian_addrCB3"] == "True" ? true : false;
              axiosThis.nominee3.g3_addr = data["guardian3"]["Guardian_addr3"] ? data["guardian3"]["Guardian_addr3"] : "";
              axiosThis.nominee3.g3_city = data["guardian3"]["Guardian_city3"] ? data["guardian3"]["Guardian_city3"] : "";
              axiosThis.nominee3.g3_state = data["guardian3"]["Guardian_state3"] ? data["guardian3"]["Guardian_state3"] : "";
              axiosThis.nominee3.g3_country = data["guardian3"]["Guardian_country3"] ? data["guardian3"]["Guardian_country3"] : "";
              axiosThis.nominee3.g3_pincode = data["guardian3"]["Guardian_pincode3"] ? data["guardian3"]["Guardian_pincode3"] : "";
            }
          }
          if (axiosThis.nom == "Yes" && axiosThis.nominee1.n1_percent == "") {
            axiosThis.nominee1.n1_percent = 100;
          }
          axiosThis.cardloader = false;
          axiosThis.getSameaddress();
        })
        .catch(function (error) {
          console.log(error);
          axiosThis.$emit("snack", 0, error);
        });
    },
  },

  computed: {
    relationitems1() {
    const disableForSingle = [
      "Son", "Daughter", "Husband", "Wife", "Grand-Son", "Grand-Daughter"
    ];
    return this.relationitems.map(item => ({
      text: item,
      value: item,
      disabled: this.getstatresponce.marital_status === 'single' && disableForSingle.includes(item)
    }));
  },
    n1_nameErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_name.$dirty) return errors;
      !this.$v.nominee1.n1_name.required && errors.push("Mandatory Field");
      !this.$v.nominee1.n1_name.minLength && errors.push("Must be valid");
      return errors;
    },
    g1_nameErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_name.$dirty) return errors;
      !this.$v.nominee1.g1_name.required && errors.push("Mandatory Field");
      !this.$v.nominee1.g1_name.minLength && errors.push("Must be valid");
      return errors;
    },
    n1_dobErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_dob.$dirty) return errors;
      !this.$v.nominee1.n1_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_relationErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_relation.$dirty) return errors;
      !this.$v.nominee1.n1_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_percentErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_percent.$dirty) return errors;
      !this.$v.nominee1.n1_percent.between && errors.push("Enter valid share");
      !this.$v.nominee1.n1_percent.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_addrErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_addr.$dirty) return errors;
      !this.$v.nominee1.n1_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee1.n1_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_cityErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_city.$dirty) return errors;
      !this.$v.nominee1.n1_city.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_stateErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_state.$dirty) return errors;
      !this.$v.nominee1.n1_state.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_countryErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_country.$dirty) return errors;
      !this.$v.nominee1.n1_country.required && errors.push("Mandatory Field");
      return errors;
    },
    n1_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee1.n1_pincode.$dirty) return errors;
      !this.$v.nominee1.n1_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee1.n1_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_dobErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_dob.$dirty) return errors;
      !this.$v.nominee1.g1_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_relationErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_relation.$dirty) return errors;
      !this.$v.nominee1.g1_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_addrErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_addr.$dirty) return errors;
      !this.$v.nominee1.g1_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee1.g1_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_cityErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_city.$dirty) return errors;
      !this.$v.nominee1.g1_city.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_stateErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_state.$dirty) return errors;
      !this.$v.nominee1.g1_state.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_countryErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_country.$dirty) return errors;
      !this.$v.nominee1.g1_country.required && errors.push("Mandatory Field");
      return errors;
    },
    g1_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee1.g1_pincode.$dirty) return errors;
      !this.$v.nominee1.g1_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee1.g1_pincode.required && errors.push("Mandatory Field");
      return errors;
    },

    n2_nameErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_name.$dirty) return errors;
      !this.$v.nominee2.n2_name.required && errors.push("Mandatory Field");
      !this.$v.nominee2.n2_name.minLength && errors.push("Must be valid");
      return errors;
    },
    g2_nameErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_name.$dirty) return errors;
      !this.$v.nominee2.g2_name.required && errors.push("Mandatory Field");
      !this.$v.nominee2.g2_name.minLength && errors.push("Must be valid");
      return errors;
    },
    n2_dobErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_dob.$dirty) return errors;
      !this.$v.nominee2.n2_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_relationErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_relation.$dirty) return errors;
      !this.$v.nominee2.n2_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_percentErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_percent.$dirty) return errors;
      !this.$v.nominee2.n2_percent.between && errors.push("Enter valid share");
      !this.$v.nominee2.n2_percent.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_addrErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_addr.$dirty) return errors;
      !this.$v.nominee2.n2_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee2.n2_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_cityErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_city.$dirty) return errors;
      !this.$v.nominee2.n2_city.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_stateErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_state.$dirty) return errors;
      !this.$v.nominee2.n2_state.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_countryErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_country.$dirty) return errors;
      !this.$v.nominee2.n2_country.required && errors.push("Mandatory Field");
      return errors;
    },
    n2_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee2.n2_pincode.$dirty) return errors;
      !this.$v.nominee2.n2_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee2.n2_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_dobErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_dob.$dirty) return errors;
      !this.$v.nominee2.g2_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_relationErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_relation.$dirty) return errors;
      !this.$v.nominee2.g2_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_addrErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_addr.$dirty) return errors;
      !this.$v.nominee2.g2_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee2.g2_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_cityErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_city.$dirty) return errors;
      !this.$v.nominee2.g2_city.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_stateErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_state.$dirty) return errors;
      !this.$v.nominee2.g2_state.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_countryErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_country.$dirty) return errors;
      !this.$v.nominee2.g2_country.required && errors.push("Mandatory Field");
      return errors;
    },
    g2_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee2.g2_pincode.$dirty) return errors;
      !this.$v.nominee2.g2_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee2.g2_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_nameErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_name.$dirty) return errors;
      !this.$v.nominee3.n3_name.required && errors.push("Mandatory Field");
      !this.$v.nominee3.n3_name.minLength && errors.push("Must be valid");
      return errors;
    },
    g3_nameErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_name.$dirty) return errors;
      !this.$v.nominee3.g3_name.required && errors.push("Mandatory Field");
      !this.$v.nominee3.g3_name.minLength && errors.push("Must be valid");
      return errors;
    },
    n3_dobErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_dob.$dirty) return errors;
      !this.$v.nominee3.n3_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_relationErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_relation.$dirty) return errors;
      !this.$v.nominee3.n3_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_percentErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_percent.$dirty) return errors;
      !this.$v.nominee3.n3_percent.between && errors.push("Enter valid share");
      !this.$v.nominee3.n3_percent.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_addrErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_addr.$dirty) return errors;
      !this.$v.nominee3.n3_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee3.n3_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_cityErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_city.$dirty) return errors;
      !this.$v.nominee3.n3_city.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_stateErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_state.$dirty) return errors;
      !this.$v.nominee3.n3_state.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_countryErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_country.$dirty) return errors;
      !this.$v.nominee3.n3_country.required && errors.push("Mandatory Field");
      return errors;
    },
    n3_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee3.n3_pincode.$dirty) return errors;
      !this.$v.nominee3.n3_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee3.n3_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_dobErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_dob.$dirty) return errors;
      !this.$v.nominee3.g3_dob.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_relationErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_relation.$dirty) return errors;
      !this.$v.nominee3.g3_relation.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_addrErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_addr.$dirty) return errors;
      !this.$v.nominee3.g3_addr.maxLength && errors.push("Address must be at most 100 characters long");
      !this.$v.nominee3.g3_addr.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_cityErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_city.$dirty) return errors;
      !this.$v.nominee3.g3_city.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_stateErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_state.$dirty) return errors;
      !this.$v.nominee3.g3_state.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_countryErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_country.$dirty) return errors;
      !this.$v.nominee3.g3_country.required && errors.push("Mandatory Field");
      return errors;
    },
    g3_pincodeErrors() {
      const errors = [];
      if (!this.$v.nominee3.g3_pincode.$dirty) return errors;
      !this.$v.nominee3.g3_pincode.between && errors.push("invalid pincode");
      !this.$v.nominee3.g3_pincode.required && errors.push("Mandatory Field");
      return errors;
    },
n1_mobileerror() {
  const errors = [];
  const mobile = this.$v.nominee1.n1_mobile;
  if (!mobile) return errors;
  if (!mobile.required) {
    errors.push("Mobile number is required");
  }
  if (!mobile.minLength || !mobile.maxLength) {
    errors.push("Mobile number must be 10 digits");
  }
  if (!mobile.startsWithValidDigit) {
    errors.push("Enter a valid number");
  }
  return errors;
},


   n1_emailerror() {
  const errors = [];
  const email = this.$v.nominee1.n1_email;

  if (!email) return errors;

  if (!email.required) {
    errors.push("Email is required");
  }

  if (!email.strictEmail) {
    errors.push("Enter a valid email address");
  }

  return errors;
},
      n2_mobileerror() {
  const errors = [];
  const mobile = this.$v.nominee2.n2_mobile;
  if (!mobile) return errors;
  if (!mobile.required) {
    errors.push("Mobile number is required");
  }
  if (!mobile.minLength || !mobile.maxLength) {
    errors.push("Mobile number must be exactly 10 digits");
  }
  if (!mobile.startsWithValidDigit) {
    errors.push("Enter a valid number");
  }
  return errors;
},
     n2_emailerror() {
  const errors = [];
  const email = this.$v.nominee2.n2_email;

  if (!email) return errors;

  if (!email.required) {
    errors.push("Email is required");
  }

  if (!email.strictEmail) {
    errors.push("Enter a valid email address");
  }

  return errors;
},
     n3_mobileerror() {
  const errors = [];
  const mobile = this.$v.nominee3.n3_mobile;
  if (!mobile) return errors;
  if (!mobile.required) {
    errors.push("Mobile number is required");
  }
  if (!mobile.minLength || !mobile.maxLength) {
    errors.push("Mobile number must be exactly 10 digits");
  }
  if (!mobile.startsWithValidDigit) {
    errors.push("Enter a valid number");
  }

  return errors;
},

      n3_emailerror() {
  const errors = [];
  const email = this.$v.nominee3.n3_email;
  if (!email) return errors;
  if (!email.required) {
    errors.push("Email is required");
  }
  if (!email.strictEmail) {
    errors.push("Enter a valid email address");
  }
  return errors;
},
 n1_idproofErrors() {
  const errors = [];
  const field = this.$v?.nominee1?.n1_proofType;
  if (!field || !field.$dirty) return errors;
  if (!field.required) errors.push("ID Proof is required");
  return errors;
},

    n1_proofErrors() {
      const errors = [];
      const field = this.$v.nominee1.n1_pan;
      if (!field.$dirty) return errors;
      if (!field.required) errors.push("Proof value is required");

      if (!field.conditionalFormat) {
        switch (this.nominee1.n1_proofType) {
          case "PAN Number":
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            break;
          case "Aadhaar number(last 4 digits)":
            errors.push("Must be exactly 4 digits");
            break;
          case "Driving Licence Number":
            errors.push("Invalid Driving Licence format");
            break;
          default:
            errors.push("Select a valid ID proof");
        }
      }
      return errors;
    },

     n2_idproofErrors() {
      const errors = [];
      const field = this.$v.nominee2.n2_proofType;
      if (!field.$dirty) return errors;
      if (!field.required) errors.push("ID Proof is required");
      return errors;
    },
    n2_proofErrors() {
      const errors = [];
      const field = this.$v.nominee2.n2_pan;
      if (!field.$dirty) return errors;
      if (!field.required) errors.push("Proof value is required");

      if (!field.conditionalFormat) {
        switch (this.nominee2.n2_proofType) {
          case "PAN Number":
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            break;
          case "Aadhaar number(last 4 digits)":
            errors.push("Must be exactly 4 digits");
            break;
          case "Driving Licence Number":
            errors.push("Invalid Driving Licence format");
            break;
          default:
            errors.push("Select a valid ID proof");
        }
      }
      return errors;
    },

         n3_idproofErrors() {
      const errors = [];
      const field = this.$v.nominee3.n3_proofType;
      if (!field.$dirty) return errors;
      if (!field.required) errors.push("ID Proof is required");
      return errors;
    },
    n3_proofErrors() {
      const errors = [];
      const field = this.$v.nominee3.n3_pan;
      if (!field.$dirty) return errors;
      if (!field.required) errors.push("Proof value is required");

      if (!field.conditionalFormat) {
        switch (this.nominee3.n3_proofType) {
          case "PAN Number":
            errors.push("Invalid PAN format (e.g. ABCDE1234F)");
            break;
          case "Aadhaar number(last 4 digits)":
            errors.push("Must be exactly 4 digits");
            break;
          case "Driving Licence Number":
            errors.push("Invalid Driving Licence format");
            break;
          default:
            errors.push("Select a valid ID proof");
        }
      }
      return errors;
    },


  

  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.dataloader = true;
    var axiosThis = this;
    var json_data = {
      mobile: atob(localStorage.getItem("hash")),
    };
    var config = {
      method: "post",
      url: api.api_url + "/signupGetUserPersonalDetails",
      headers: {"Content-Type": "application/json"},
      data: JSON.stringify(json_data),
    };
    axios(config)
      .then(function (response) {
        var data = response.data;
        if (data) {
          if (data["nominee_check"] == "Yes") {
            axiosThis.getNomineedata();
            axiosThis.nomis = 1;
          }
          axiosThis.nom = data["nominee_check"];
          axiosThis.nomineedata = data;
        }
        axiosThis.cardloader = false;
        axiosThis.dataloader = false;
      })
      .catch(function (error) {
        console.log(error);
        axiosThis.$emit("snack", 0, error);
      });
  },
};
</script>
